// ── ESTAMPAS ──
const ESTAMPAS = [
  // ── TEXTURA 1 ──
  {
    id: 'texturamanga1',
    nome: 'Textura 1',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura1swatch.webp',
    regiao: 'manga',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaMangaGERAL.webp', cor: '#0a0a0a', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga1-2.webp', cor: '#5c5d61', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga1-3.webp', cor: '#c80e0e', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturatronco1',
    nome: 'Textura 1',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura1swatch.webp',
    regiao: 'tronco',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTroncoGERAL.webp', cor: '#0a0a0a', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco1-2.webp', cor: '#5c5d61', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco1-3.webp', cor: '#c80e0e', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturashorts1',
    nome: 'Textura 1',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura1swatch.webp',
    regiao: 'shorts',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShortsGERAL.webp', cor: '#0a0a0a', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts1-2.webp', cor: '#5c5d61', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts1-3.webp', cor: '#c80e0e', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturalateral1',
    nome: 'Textura 1',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura1swatch.webp',
    regiao: 'lateral',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateralGERAL.webp', cor: '#0a0a0a', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral1-2.webp', cor: '#5c5d61', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral1-3.webp', cor: '#c80e0e', nome: 'Camada 3' },
    ]
  },
  // ── TEXTURA 2 ──
  {
    id: 'texturamanga2',
    nome: 'Textura 2',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura2swatch.webp',
    regiao: 'manga',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaMangaGERAL.webp', cor: '#f3e9d8', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga2-2.webp', cor: '#f05d00', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga2-3.webp', cor: '#ff7700', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturatronco2',
    nome: 'Textura 2',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura2swatch.webp',
    regiao: 'tronco',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTroncoGERAL.webp', cor: '#f3e9d8', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco2-2.webp', cor: '#f05d00', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco2-3.webp', cor: '#ff7700', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturashorts2',
    nome: 'Textura 2',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura2swatch.webp',
    regiao: 'shorts',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShortsGERAL.webp', cor: '#f3e9d8', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts2-2.webp', cor: '#f05d00', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts2-3.webp', cor: '#ff7700', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturalateral2',
    nome: 'Textura 2',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura2swatch.webp',
    regiao: 'lateral',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateralGERAL.webp', cor: '#f3e9d8', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral2-2.webp', cor: '#f05d00', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral2-3.webp', cor: '#ff7700', nome: 'Camada 3' },
    ]
  },
  // ── TEXTURA 3 ──
  {
    id: 'texturamanga3',
    nome: 'Textura 3',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura3swatch.webp',
    regiao: 'manga',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaMangaGERAL.webp', cor: '#0a0a0a', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga3-2.webp', cor: '#a31cfd', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga3-3.webp', cor: '#ff299b', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturatronco3',
    nome: 'Textura 3',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura3swatch.webp',
    regiao: 'tronco',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTroncoGERAL.webp', cor: '#0a0a0a', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco3-2.webp', cor: '#a31cfd', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco3-3.webp', cor: '#ff299b', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturashorts3',
    nome: 'Textura 3',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura3swatch.webp',
    regiao: 'shorts',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShortsGERAL.webp', cor: '#0a0a0a', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts3-2.webp', cor: '#a31cfd', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts3-3.webp', cor: '#ff299b', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturalateral3',
    nome: 'Textura 3',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura3swatch.webp',
    regiao: 'lateral',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateralGERAL.webp', cor: '#0a0a0a', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral3-2.webp', cor: '#a31cfd', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral3-3.webp', cor: '#ff299b', nome: 'Camada 3' },
    ]
  },
  // ── TEXTURA 4 ──
  {
    id: 'texturamanga4',
    nome: 'Textura 4',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura4swatch.webp',
    regiao: 'manga',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaMangaGERAL.webp', cor: '#2b2b2b', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga4-2.webp', cor: '#0e39e1', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga4-3.webp', cor: '#0062ff', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturatronco4',
    nome: 'Textura 4',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura4swatch.webp',
    regiao: 'tronco',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTroncoGERAL.webp', cor: '#2b2b2b', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco4-2.webp', cor: '#0e39e1', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco4-3.webp', cor: '#0062ff', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturashorts4',
    nome: 'Textura 4',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura4swatch.webp',
    regiao: 'shorts',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShortsGERAL.webp', cor: '#2b2b2b', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts4-2.webp', cor: '#0e39e1', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts4-3.webp', cor: '#0062ff', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturalateral4',
    nome: 'Textura 4',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura4swatch.webp',
    regiao: 'lateral',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateralGERAL.webp', cor: '#2b2b2b', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral4-2.webp', cor: '#0e39e1', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral4-3.webp', cor: '#0062ff', nome: 'Camada 3' },
    ]
  },
  // ── TEXTURA 5 ──
  {
    id: 'texturamanga5',
    nome: 'Textura 5',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura5swatch.webp',
    regiao: 'manga',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaMangaGERAL.webp', cor: '#118a7c', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga5-2.webp', cor: '#14b8a6', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga5-3.webp', cor: '#02decf', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturatronco5',
    nome: 'Textura 5',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura5swatch.webp',
    regiao: 'tronco',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTroncoGERAL.webp', cor: '#118a7c', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco5-2.webp', cor: '#14b8a6', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco5-3.webp', cor: '#02decf', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturashorts5',
    nome: 'Textura 5',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura5swatch.webp',
    regiao: 'shorts',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShortsGERAL.webp', cor: '#118a7c', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts5-2.webp', cor: '#14b8a6', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts5-3.webp', cor: '#02decf', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturalateral5',
    nome: 'Textura 5',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura5swatch.webp',
    regiao: 'lateral',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateralGERAL.webp', cor: '#118a7c', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral5-2.webp', cor: '#14b8a6', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral5-3.webp', cor: '#02decf', nome: 'Camada 3' },
    ]
  },
  // ── TEXTURA 6 ──
  {
    id: 'texturamanga6',
    nome: 'Textura 6',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura6swatch.webp',
    regiao: 'manga',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaMangaGERAL.webp', cor: '#800048', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga6-2.webp', cor: '#bf026d', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga6-3.webp', cor: '#d401b5', nome: 'Camada 3' },
      { id: 'cam4', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga6-4.webp', cor: '#c036cf', nome: 'Camada 4' },
    ]
  },
  {
    id: 'texturatronco6',
    nome: 'Textura 6',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura6swatch.webp',
    regiao: 'tronco',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTroncoGERAL.webp', cor: '#800048', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco6-2.webp', cor: '#bf026d', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco6-3.webp', cor: '#d401b5', nome: 'Camada 3' },
      { id: 'cam4', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco6-4.webp', cor: '#c036cf', nome: 'Camada 4' },
    ]
  },
  {
    id: 'texturashorts6',
    nome: 'Textura 6',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura6swatch.webp',
    regiao: 'shorts',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShortsGERAL.webp', cor: '#800048', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts6-2.webp', cor: '#bf026d', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts6-3.webp', cor: '#d401b5', nome: 'Camada 3' },
      { id: 'cam4', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts6-4.webp', cor: '#c036cf', nome: 'Camada 4' },
    ]
  },
  {
    id: 'texturalateral6',
    nome: 'Textura 6',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura6swatch.webp',
    regiao: 'lateral',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateralGERAL.webp', cor: '#800048', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral6-2.webp', cor: '#bf026d', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral6-3.webp', cor: '#d401b5', nome: 'Camada 3' },
      { id: 'cam4', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral6-4.webp', cor: '#c036cf', nome: 'Camada 4' },
    ]
  },
  // ── TEXTURA 7 ──
  {
    id: 'texturamanga7',
    nome: 'Textura 7',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura7swatch.webp',
    regiao: 'manga',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaMangaGERAL.webp', cor: '#ffffff', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga7-2.webp', cor: '#fed20b', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga7-3.webp', cor: '#f5aa08', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturatronco7',
    nome: 'Textura 7',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura7swatch.webp',
    regiao: 'tronco',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTroncoGERAL.webp', cor: '#ffffff', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco7-2.webp', arquivoFEM: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco7-2FEM_v3.webp', cor: '#fed20b', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco7-3.webp', arquivoFEM: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco7-3FEM_v3.webp', cor: '#f5aa08', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturashorts7',
    nome: 'Textura 7',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura7swatch.webp',
    regiao: 'shorts',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShortsGERAL.webp', cor: '#ffffff', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts7-2.webp', cor: '#fed20b', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts7-3.webp', cor: '#f5aa08', nome: 'Camada 3' },
    ]
  },
  {
    id: 'texturalateral7',
    nome: 'Textura 7',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura7swatch.webp',
    regiao: 'lateral',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateralGERAL.webp', cor: '#ffffff', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral7-2.webp', cor: '#fed20b', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral7-3.webp', cor: '#f5aa08', nome: 'Camada 3' },
    ]
  },
  // ── TEXTURA 8 ──
  {
    id: 'texturamanga8',
    nome: 'Textura 8',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura8swatch.webp',
    regiao: 'manga',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaMangaGERAL.webp', cor: '#42a4c2', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga8-2.webp', cor: '#3087a1', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga8-3.webp', cor: '#ffffff', nome: 'Camada 3' },
      { id: 'cam4', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga8-4.webp', cor: '#16678d', nome: 'Camada 4' },
    ]
  },
  {
    id: 'texturatronco8',
    nome: 'Textura 8',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura8swatch.webp',
    regiao: 'tronco',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTroncoGERAL.webp', cor: '#42a4c2', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco8-2.webp', cor: '#3087a1', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco8-3.webp', cor: '#ffffff', nome: 'Camada 3' },
      { id: 'cam4', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco8-4.webp', cor: '#16678d', nome: 'Camada 4' },
    ]
  },
  {
    id: 'texturashorts8',
    nome: 'Textura 8',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura8swatch.webp',
    regiao: 'shorts',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShortsGERAL.webp', cor: '#42a4c2', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts8-2.webp', cor: '#3087a1', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts8-3.webp', cor: '#ffffff', nome: 'Camada 3' },
      { id: 'cam4', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts8-4.webp', cor: '#16678d', nome: 'Camada 4' },
    ]
  },
  {
    id: 'texturalateral8',
    nome: 'Textura 8',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura8swatch.webp',
    regiao: 'lateral',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateralGERAL.webp', cor: '#42a4c2', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral8-2.webp', cor: '#3087a1', nome: 'Camada 2' },
      { id: 'cam3', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral8-3.webp', cor: '#ffffff', nome: 'Camada 3' },
      { id: 'cam4', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral8-4.webp', cor: '#16678d', nome: 'Camada 4' },
    ]
  },
  // ── TEXTURA 9 ──
  {
    id: 'texturamanga9',
    nome: 'Textura 9',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura9swatch.webp',
    regiao: 'manga',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaMangaGERAL.webp', cor: '#006838', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaManga9-2.webp', cor: '#1a1a1a', nome: 'Camada 2' },
    ]
  },
  {
    id: 'texturatronco9',
    nome: 'Textura 9',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura9swatch.webp',
    regiao: 'tronco',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTroncoGERAL.webp', cor: '#006838', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaTronco9-2.webp', cor: '#1a1a1a', nome: 'Camada 2' },
    ]
  },
  {
    id: 'texturashorts9',
    nome: 'Textura 9',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura9swatch.webp',
    regiao: 'shorts',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShortsGERAL.webp', cor: '#006838', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaShorts9-2.webp', cor: '#1a1a1a', nome: 'Camada 2' },
    ]
  },
  {
    id: 'texturalateral9',
    nome: 'Textura 9',
    thumb: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/textura9swatch.webp',
    regiao: 'lateral',
    camadas: [
      { id: 'cam1', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateralGERAL.webp', cor: '#006838', nome: 'Camada 1' },
      { id: 'cam2', arquivo: 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/TexturaLateral9-2.webp', cor: '#1a1a1a', nome: 'Camada 2' },
    ]
  },
];

const estampaAtivaMap = { manga: null, tronco: null, shorts: null, lateral: null };

async function ativarEstampa(regiao, id) {
  const svg = document.querySelector('#mockup-wrap svg');
  if (!svg) return;

  const removerCamadas = () => {
    svg.querySelectorAll(`[data-estampa-regiao="${regiao}"]`).forEach(el => {
      if (el.tagName === 'image') el.setAttribute('href', '');
      el.remove();
    });
    const defs = svg.querySelector('defs');
    if (defs) defs.querySelectorAll(`[data-estampa-regiao="${regiao}"]`).forEach(el => el.remove());
  };

  if (id === estampaAtivaMap[regiao] || id === null) {
    const ease = 'opacity 0.4s cubic-bezier(0.22,1,0.36,1)';
    svg.querySelectorAll(`[data-estampa-regiao="${regiao}"]`).forEach(el => {
      el.style.transition = ease;
      el.style.opacity = '0';
    });
    setTimeout(() => { removerCamadas(); }, 420);
    estampaAtivaMap[regiao] = null;
    if (regiao === 'tronco') {
      const ht = document.getElementById('parte-webp-halftone');
      if (ht) { ht.style.transition = ease; ht.style.opacity = '0'; setTimeout(() => { ht.style.display = 'none'; ht.style.transition = ''; ht.style.opacity = ''; }, 420); }
    }
    atualizarUIEstampa(regiao);
    return;
  }

  removerCamadas();
  estampaAtivaMap[regiao] = id;
  const estampa = ESTAMPAS.find(e => e.id === id);
  if (!estampa) return;

  const defs = svg.querySelector('defs');
  const anchorEl = regiao === 'lateral'
    ? document.getElementById('parte-webp-listras')
    : document.getElementById('parte-webp-halftone');
  const anchor = (regiao === 'lateral' && anchorEl) ? anchorEl.nextSibling : anchorEl;

  // 1. Criar elementos de textura com opacity 0
  const textureImgs = [];
  for (const camada of estampa.camadas) {
    const filterId = `estampa-color-${regiao}-${id}-${camada.id}`;
    const floodId  = `estampa-flood-${regiao}-${id}-${camada.id}`;

    const filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
    filter.setAttribute('id', filterId);
    filter.setAttribute('x', '0'); filter.setAttribute('y', '0');
    filter.setAttribute('width', '1'); filter.setAttribute('height', '1');
    filter.setAttribute('color-interpolation-filters', 'sRGB');
    filter.setAttribute('data-estampa-regiao', regiao);

    const flood = document.createElementNS('http://www.w3.org/2000/svg', 'feFlood');
    flood.setAttribute('id', floodId);
    flood.setAttribute('flood-color', camada.cor);
    flood.setAttribute('result', 'color');

    const composite = document.createElementNS('http://www.w3.org/2000/svg', 'feComposite');
    composite.setAttribute('in', 'color');
    composite.setAttribute('in2', 'SourceGraphic');
    composite.setAttribute('operator', 'in');

    filter.appendChild(flood);
    filter.appendChild(composite);
    defs.appendChild(filter);

    const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
    img.setAttribute('id', `estampa-webp-${regiao}-${id}-${camada.id}`);
    img.setAttribute('data-estampa-regiao', regiao);
    img.setAttribute('href', mUrlTextura(gUrlCamada(camada)));
    img.setAttribute('x', '0'); img.setAttribute('y', '0');
    img.setAttribute('width', '2040'); img.setAttribute('height', '1734');
    img.setAttribute('filter', `url(#${filterId})`);
    img.style.opacity = '0';
    img.style.transition = 'none';

    svg.insertBefore(img, anchor);
    textureImgs.push({ img, src: mUrlTextura(gUrlCamada(camada)) });
  }

  // 2. Halftone aparece imediatamente
  if (regiao === 'tronco') {
    const ease = 'cubic-bezier(0.22,1,0.36,1)';
    const ht = document.getElementById('parte-webp-halftone');
    if (ht) {
      ht.style.display = '';
      ht.style.transition = 'none';
      ht.style.opacity = '0';
      void ht.getBoundingClientRect();
      ht.style.transition = `opacity 0.4s ${ease}`;
      ht.style.opacity = '1';
      setTimeout(() => { ht.style.transition = ''; ht.style.opacity = ''; }, 450);
    }
  }

  // 3. Pré-carregar texturas em paralelo antes do fade
  await Promise.all(textureImgs.map(({ src }) =>
    new Promise(r => { const i = new Image(); i.onload = i.onerror = r; i.src = src; })
  ));

  // 4. Fade in
  for (const { img } of textureImgs) {
    void img.getBoundingClientRect();
    img.style.transition = 'opacity 0.4s cubic-bezier(0.22,1,0.36,1)';
    img.style.opacity = '1';
    setTimeout(() => { img.style.transition = ''; img.style.opacity = ''; }, 450);
  }

  atualizarUIEstampa(regiao);
}


function aplicarHalftoneTronco() {
  const flood = document.getElementById('parte-filter-flood-halftone');
  if (flood) {
    const cor = coresPorParte['tronco'] || corAtual.hex;
    flood.setAttribute('flood-color', cor);
  }
  const mascaraFlood = document.getElementById('parte-filter-flood-mascara-original');
  if (mascaraFlood) {
    const cor = coresPorParte['tronco'] || corAtual.hex;
    mascaraFlood.setAttribute('flood-color', cor);
  }
  const mascaraMangaFlood = document.getElementById('parte-filter-flood-mascara-original-manga');
  if (mascaraMangaFlood) {
    const cor = coresPorParte['tronco'] || corAtual.hex;
    mascaraMangaFlood.setAttribute('flood-color', cor);
  }
  const mascaraSignMangaFlood = document.getElementById('parte-filter-flood-mascara-signature-manga');
  if (mascaraSignMangaFlood) {
    const cor = coresPorParte['tronco'] || corAtual.hex;
    mascaraSignMangaFlood.setAttribute('flood-color', cor);
  }
}

function setCamadaCor(regiao, estampaId, camadaId, hex) {
  const flood = document.getElementById(`estampa-flood-${regiao}-${estampaId}-${camadaId}`);
  if (flood) flood.setAttribute('flood-color', hex);
  const estampa = ESTAMPAS.find(e => e.id === estampaId);
  if (estampa) {
    const camada = estampa.camadas.find(c => c.id === camadaId);
    if (camada) camada.cor = hex;
  }
}

function atualizarUIEstampa(regiao) {
  const ativa = estampaAtivaMap[regiao];

  document.querySelectorAll(`.estampa-thumb[data-regiao="${regiao}"]`).forEach(t => {
    t.classList.toggle('active', t.dataset.id === (ativa || ''));
  });

  const painel = document.getElementById(`estampa-${regiao}-cores-painel`);
  if (!painel) return;
  painel.innerHTML = '';
  if (!ativa) return;

  const estampa = ESTAMPAS.find(e => e.id === ativa);
  if (!estampa) return;

  estampa.camadas.forEach(camada => {
    const row = document.createElement('div');
    row.className = 'camada-item';
    const lbl = document.createElement('span');
    lbl.className = 'parte-label';
    lbl.textContent = camada.nome;
    const btns = document.createElement('div');
    btns.className = 'parte-btns';
    const wrapper = document.createElement('div');
    wrapper.className = 'parte-wrapper';
    const btnCor = document.createElement('div');
    btnCor.className = 'parte-btn-cor active';
    btnCor.style.background = camada.cor;
    btnCor.style.setProperty('--swatch-color', camada.cor);
    const popover = document.createElement('div');
    popover.className = 'color-picker-popover popover-direita';
    const popTitle = document.createElement('div');
    popTitle.className = 'popover-title';
    popTitle.textContent = camada.nome;
    const { groupRow: estGroupRow, toneRow: estToneRow, reset: resetEst } = criarSeletorCores({
      groupClass: 'pop-swatch',
      toneClass: 'pop-swatch',
      getHexAtivo: () => camada.cor,
      isProibido: null,
      onSelectTom: tom => {
        setCamadaCor(regiao, ativa, camada.id, tom.hex);
        btnCor.style.background = tom.hexSwatch || tom.hex;
        btnCor.style.setProperty('--swatch-color', tom.hexSwatch || tom.hex);
        applySwatchShadow(btnCor, tom.hexSwatch || tom.hex);
        fecharPopovers();
      }
    });
    estGroupRow.className += ' popover-swatches';
    estToneRow.className += ' popover-tones';
    popover.appendChild(popTitle);
    popover.appendChild(estGroupRow);
    popover.appendChild(estToneRow);
    btnCor.onclick = e => {
      e.stopPropagation();
      const jaAberto = popover.classList.contains('open');
      fecharPopovers();
      if (!jaAberto) { resetEst(); abrirPopover(popover); }
    };
    wrapper.appendChild(btnCor);
    wrapper.appendChild(popover);
    btns.appendChild(wrapper);
    row.appendChild(lbl);
    row.appendChild(btns);
    painel.appendChild(row);
  });
}

function buildEstampas() {
  ['manga', 'lateral', 'tronco', 'shorts'].forEach(regiao => {
    const container = document.getElementById(`estampas-${regiao}-thumbs`);
    if (!container) return;

    const btnNenhuma = document.createElement('div');
    btnNenhuma.className = 'estampa-thumb active';
    btnNenhuma.dataset.id = '';
    btnNenhuma.dataset.regiao = regiao;
    btnNenhuma.title = 'Sem estampa';
    btnNenhuma.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="4" y1="4" x2="20" y2="20"/><line x1="20" y1="4" x2="4" y2="20"/></svg>`;
    btnNenhuma.onclick = () => { triggerSwatchClick(btnNenhuma); ativarEstampa(regiao, null); };
    container.appendChild(btnNenhuma);

    ESTAMPAS.filter(e => e.regiao === regiao).forEach(estampa => {
      const thumb = document.createElement('div');
      thumb.className = 'estampa-thumb';
      thumb.dataset.id = estampa.id;
      thumb.dataset.regiao = regiao;
      thumb.title = estampa.nome;
      thumb.style.backgroundImage = `url('${estampa.thumb}')`;
      thumb.style.backgroundSize = '120%';
      thumb.style.backgroundPosition = 'center';
      thumb.style.backgroundRepeat = 'no-repeat';
      thumb.onclick = () => { triggerSwatchClick(thumb); ativarEstampa(regiao, estampa.id); };
      container.appendChild(thumb);
    });
  });
}

// ── CLICK FEEDBACK ──
function triggerSwatchClick(el) {
  el.classList.remove('swatch-clicked');
  void el.getBoundingClientRect(); // reflow
  el.classList.add('swatch-clicked');
  setTimeout(() => el.classList.remove('swatch-clicked'), 750);
}

const GRUPOS_CORES = [
  {rep:{name:"Preto",hex:"#0a0a0a",hexSwatch:"#0a0a0a"},tons:[{name:"Preto",hex:"#0a0a0a",hexSwatch:"#0a0a0a"},{name:"Grafite escuro",hex:"#1a1a1a",hexSwatch:"#1f1f1fff"},{name:"Grafite",hex:"#232324",hexSwatch:"#353536"},{name:"Preto Fosco",hex:"#2b2b2b",hexSwatch:"#454545"},{name:"Chumbo",hex:"#343b46",hexSwatch:"#4d525c"},{name:"Cinza Escuro",hex:"#494a50",hexSwatch:"#5c5d61"}]},
  {rep:{name:"Cinza",hex:"#6b7280",hexSwatch:"#7c8088"},tons:[{name:"Cinza",hex:"#6f7076",hexSwatch:"#777a83"},{name:"Cinza Médio",hex:"#92959b",hexSwatch:"#9ea0a3"},{name:"Prata",hex:"#c0c0c0",hexSwatch:"#c0c0c0"},{name:"Cinza Claro",hex:"#c6c7c7",hexSwatch:"#c6c7c7"},{name:"Cinza Gelo",hex:"#d5dae1",hexSwatch:"#d5dae1"}]},
  {rep:{name:"Branco",hex:"#f5f5f5",hexSwatch:"#f5f5f5"},tons:[{name:"Branco Puro",hex:"#ffffff",hexSwatch:"#ffffff"},{name:"Branco Gelo",hex:"#edeef2",hexSwatch:"#edeef2"},{name:"Off-White",hex:"#fdf6e7",hexSwatch:"#fdf6e7"},{name:"Off-White Creme",hex:"#f3e9d8",hexSwatch:"#ece3d4"},{name:"Marfim",hex:"#f3e6ce",hexSwatch:"#ede4d3"}]},
  {rep:{name:"Azul Marinho",hex:"#001f5b",hexSwatch:"#001f5b"},tons:[{name:"Azul Meia Noite",hex:"#0d1b4b",hexSwatch:"#0d1b4b"},{name:"Azul Marinho",hex:"#052566",hexSwatch:"#214282"},{name:"Azul Prússia",hex:"#002742",hexSwatch:"#13354e"},{name:"Azul Aço",hex:"#133553",hexSwatch:"#1c3d5a"},{name:"Azul Petróleo",hex:"#003e4d",hexSwatch:"#004e5f"}]},
  {rep:{name:"Azul Royal",hex:"#1565c0",hexSwatch:"#0c32ed"},tons:[{name:"Azul Cobalto",hex:"#1d1db9",hexSwatch:"#2121c4"},{name:"Azul Royal",hex:"#0e39e1",hexSwatch:"#0c2fdf"},{name:"Azul Elétrico",hex:"#2448ff",hexSwatch:"#2e51ff"},{name:"Azul",hex:"#0062ff",hexSwatch:"#0d61e7"},{name:"Azul Escuro",hex:"#002699",hexSwatch:"#00248f"},{name:"Índigo",hex:"#10087d",hexSwatch:"#160e8b"},{name:"Azul Profundo",hex:"#16678d",hexSwatch:"#2d6985"}]},
  {rep:{name:"Azul Celeste",hex:"#29b6f6",hexSwatch:"#00aeff"},tons:[{name:"Azul Celeste",hex:"#009dff",hexSwatch:"#009dff"},{name:"Azul Claro",hex:"#14b9ff",hexSwatch:"#2ec0ff"},{name:"Azul Mediterrâneo",hex:"#5fbaf7",hexSwatch:"#70bdf0"},{name:"Azul Bebê",hex:"#90dbfe",hexSwatch:"#94ddff"},{name:"Ciano",hex:"#00b3c8",hexSwatch:"#00b3c8"},{name:"Turquesa Escuro",hex:"#118a7c",hexSwatch:"#118a7c"},{name:"Turquesa",hex:"#14b8a6",hexSwatch:"#14b8a6"},{name:"Tiffany",hex:"#02decf",hexSwatch:"#08d9cb"},{name:"Ciano Mediterrâneo",hex:"#42a4c2",hexSwatch:"#40a5c4"},{name:"Ciano Majestoso",hex:"#3087a1",hexSwatch:"#3087a1"}]},
  {rep:{name:"Verde",hex:"#16a34a",hexSwatch:"#0dab47"},tons:[{name:"Verde Floresta",hex:"#045d28",hexSwatch:"#095d2b"},{name:"Verde Musgo",hex:"#29603e",hexSwatch:"#487057"},{name:"Verde Escuro",hex:"#016003",hexSwatch:"#036d05"},{name:"Esmeralda",hex:"#006838",hexSwatch:"#0e7746ff"},{name:"Verde Brasil",hex:"#008f34",hexSwatch:"#008f34"},{name:"Verde",hex:"#1fbd21",hexSwatch:"#18bf1a"},{name:"Verde Vivo",hex:"#4ad93f",hexSwatch:"#4ad93f"},{name:"Verde Limão",hex:"#85e66b",hexSwatch:"#85e66b"},{name:"Verde Lima",hex:"#90de1b",hexSwatch:"#90de1b"},{name:"Verde Lima Claro",hex:"#c4ff6b",hexSwatch:"#c4ff6b"}]},
  {rep:{name:"Amarelo",hex:"#f59e0b",hexSwatch:"#ffdd00"},tons:[{name:"Amarelo Canário",hex:"#ffe800",hexSwatch:"#fff014"},{name:"Amarelo",hex:"#fed20b",hexSwatch:"#fed50b"},{name:"Amarelo Ouro",hex:"#fdc009",hexSwatch:"#fdc009"},{name:"Âmbar",hex:"#f5aa08",hexSwatch:"#f5aa08"},{name:"Mostarda",hex:"#eab308",hexSwatch:"#eab308"},{name:"Amarelo Claro",hex:"#ffdf3d",hexSwatch:"#ffdf3d"}]},
  {rep:{name:"Laranja",hex:"#ea580c",hexSwatch:"#fc7700"},tons:[{name:"Laranja Claro",hex:"#ff8c2e",hexSwatch:"#ff8c2e"},{name:"Laranja",hex:"#ff7700",hexSwatch:"#ff7700"},{name:"Laranja Neon",hex:"#f05d00",hexSwatch:"#f05d00"},{name:"Laranja Queimado",hex:"#df5c16",hexSwatch:"#db6729"},{name:"Telha",hex:"#c2410c",hexSwatch:"#c2410c"}]},
  {rep:{name:"Vermelho",hex:"#dc2626",hexSwatch:"#ed0c0c"},tons:[{name:"Vermelho Strawberry",hex:"#fe4c49",hexSwatch:"#fe4c49"},{name:"Vermelho",hex:"#ed0c0c",hexSwatch:"#ed0c0c"},{name:"Vermelho Carmesim",hex:"#c80e0e",hexSwatch:"#c80e0e"},{name:"Vermelho Carmim",hex:"#a80539",hexSwatch:"#a80539"},{name:"Vermelho Escuro",hex:"#aa1313",hexSwatch:"#aa1313"},{name:"Vinho Claro",hex:"#a3242a",hexSwatch:"#a3242a"},{name:"Bordô",hex:"#7d0d18",hexSwatch:"#7d0d18"},{name:"Vinho",hex:"#55020a",hexSwatch:"#5e030c"}]},
  {rep:{name:"Rosa",hex:"#db2777",hexSwatch:"#f73b90"},tons:[{name:"Magenta Escuro",hex:"#800048",hexSwatch:"#800048"},{name:"Magenta Médio",hex:"#bf026d",hexSwatch:"#bf026d"},{name:"Magenta",hex:"#df0c80",hexSwatch:"#e11584"},{name:"Pink",hex:"#ff299b",hexSwatch:"#ff33a0"},{name:"Rosa Claro",hex:"#ff57ae",hexSwatch:"#ff57ae"},{name:"Rosa Baby",hex:"#fe90cc",hexSwatch:"#fe90cc"},{name:"Rosa Melancia",hex:"#ff809d",hexSwatch:"#ff809d"},{name:"Rosa Punch",hex:"#fe4864",hexSwatch:"#fe4864"},{name:"Salmão Claro",hex:"#fda4b8",hexSwatch:"#fda4b8"},{name:"Salmão",hex:"#ff6b81",hexSwatch:"#ff6b81"},{name:"Vermelho Violeta",hex:"#d401b5",hexSwatch:"#d401b5"},{name:"Orquídea",hex:"#dd50d8",hexSwatch:"#df64db"}]},
  {rep:{name:"Roxo",hex:"#7b1fa2",hexSwatch:"#8615b7"},tons:[{name:"Orquídea Média",hex:"#c036cf",hexSwatch:"#c448d1"},{name:"Orquídea Escura",hex:"#9525ce",hexSwatch:"#9932cc"},{name:"Roxo Profundo",hex:"#67008f",hexSwatch:"#67008f"},{name:"Roxo",hex:"#8f09c8",hexSwatch:"#8f09c8"},{name:"Roxo Médio",hex:"#a31cfd",hexSwatch:"#a31cfd"},{name:"Roxo Vivo",hex:"#901cfd",hexSwatch:"#901cfd"},{name:"Lilás",hex:"#b05cff",hexSwatch:"#b05cff"},{name:"Violeta",hex:"#7a29c2",hexSwatch:"#7a29c2"},{name:"Rebecca Roxa",hex:"#602197",hexSwatch:"#602197"},{name:"Roxo Escuro",hex:"#4d0a71",hexSwatch:"#4d0a71"}]},
  {rep:{name:"Marrom",hex:"#795548",hexSwatch:"#733e2b"},tons:[{name:"Marrom Café",hex:"#44271d",hexSwatch:"#604339"},{name:"Chocolate",hex:"#4d200a",hexSwatch:"#6e3b21"},{name:"Marrom",hex:"#5b1f00",hexSwatch:"#72391d"},{name:"Caramelo",hex:"#875f4a",hexSwatch:"#946c57"},{name:"Cáqui Escuro",hex:"#9e6746",hexSwatch:"#9e6746"},{name:"Sienna",hex:"#a04c22",hexSwatch:"#a04c22"},{name:"Cobre",hex:"#bf7131",hexSwatch:"#c3793c"},{name:"Cáqui",hex:"#c6b080",hexSwatch:"#c8b488"},{name:"Nozes",hex:"#dbaf85",hexSwatch:"#dbaf85"},{name:"Areia",hex:"#f7ca97",hexSwatch:"#f7ca97"}]},
];

// Encontra um tom pelo hex (busca em todos os tons de todos os grupos)
function encontrarTomPorHex(hex) {
  if (!hex) return null;
  for (const g of GRUPOS_CORES) {
    for (const t of g.tons) {
      if (t.hex === hex) return { grupo: g, tom: t };
    }
    if (g.rep.hex === hex) return { grupo: g, tom: g.rep };
  }
  return null;
}

// Aplica borda sutil em swatches de cor clara
function applySwatchShadow(el, hexSwatch) {
  const claras = ['#f5f5f5','#f0f0f0','#ffffff','#edeef2','#fdf6e7','#f3e9d8','#f3e6ce','#ece3d4','#ede4d3','#d5dae1','#c6c7c7','#c0c0c0','#c4ff6b','#85e66b','#ffdf3d','#f7ca97','#dbaf85','#c8b488','#94ddff','#90dbfe','#fe90cc','#fda4b8'];
  if (claras.some(c => (hexSwatch||'').toLowerCase() === c.toLowerCase()))
    el.style.boxShadow = '0 1px 4px rgba(0,0,0,.12),inset 0 0 0 1px #ddd';
}

// Cria UI de seleção em dois níveis: grupos → tons
// Retorna { groupRow, toneRow } para o caller montar no DOM
function criarSeletorCores({ groupClass, toneClass, getHexAtivo, isProibido, onSelectTom }) {
  const groupRow = document.createElement('div');
  groupRow.className = 'color-group-row';

  const toneRow = document.createElement('div');
  toneRow.className = 'color-tone-row';

  let grupoAtivo = null;

  function abrirTons(g, btn) {
    grupoAtivo = g;
    groupRow.querySelectorAll('.' + groupClass).forEach(b => b.classList.remove('group-open'));
    btn.classList.add('group-open');

    toneRow.innerHTML = '';
    const hexAtivo = getHexAtivo();
    g.tons.forEach(tom => {
      const ts = document.createElement('div');
      ts.className = toneClass;
      ts.style.background = tom.hexSwatch || tom.hex;
      ts.style.setProperty('--swatch-color', tom.hexSwatch || tom.hex);
      ts.title = tom.name;
      ts.dataset.hex = tom.hex;
      applySwatchShadow(ts, tom.hexSwatch || tom.hex);
      if (hexAtivo === tom.hex) ts.classList.add('active');
      ts.onclick = e => {
        e.stopPropagation();
        if (isProibido && isProibido(tom.hex)) {
          ts.style.outline = '2px solid #ef4444';
          setTimeout(() => ts.style.outline = '', 500);
          return;
        }
        triggerSwatchClick(ts);
        toneRow.querySelectorAll('.' + toneClass.split(' ')[0]).forEach(x => x.classList.remove('active'));
        ts.classList.add('active');
        groupRow.querySelectorAll('.' + groupClass).forEach(b => b.classList.remove('group-selected'));
        btn.classList.add('group-selected');
        btn.style.background = tom.hexSwatch || tom.hex;
        btn.style.setProperty('--swatch-color', tom.hexSwatch || tom.hex);
        applySwatchShadow(btn, tom.hexSwatch || tom.hex);
        onSelectTom(tom);
      };
      toneRow.appendChild(ts);
    });
    toneRow.classList.add('open');
  }

  GRUPOS_CORES.forEach(g => {
    const s = document.createElement('div');
    s.className = groupClass;
    s.style.background = g.rep.hexSwatch || g.rep.hex;
    s.style.setProperty('--swatch-color', g.rep.hexSwatch || g.rep.hex);
    s.title = g.rep.name;
    applySwatchShadow(s, g.rep.hexSwatch || g.rep.hex);
    const hexAtivo = getHexAtivo();
    if (hexAtivo && g.tons.some(t => t.hex === hexAtivo)) s.classList.add('group-selected');

    s.onclick = e => {
      e.stopPropagation();
      triggerSwatchClick(s);
      if (grupoAtivo === g) {
        toneRow.innerHTML = '';
        toneRow.classList.remove('open');
        grupoAtivo = null;
        s.classList.remove('group-open');
        return;
      }
      abrirTons(g, s);
    };
    groupRow.appendChild(s);
  });

  function reset() {
    grupoAtivo = null;
    toneRow.innerHTML = '';
    toneRow.classList.remove('open');
    groupRow.querySelectorAll('.' + groupClass.split(' ')[0]).forEach(b => b.classList.remove('group-open'));
  }

  return { groupRow, toneRow, reset };
}

const CDN = 'https://cdn.shopify.com/s/files/1/0764/5754/1888/files/';

let genero = 'masc';
let modelo = 'signature';
const LOGO_OFFSET_FEM = {
  escudo_lado:            { x: -10, y: 76 },       // escudo "Um de cada lado"
  escudo_centro:          { x: 0,   y: 85 },       // escudo "Centralizado"
  escudo_duplo:           { x: -10,   y: 80 },       // escudo "Duplo Logo"
  escudo2:                { x: 10,   y: 80 },       // segundo logo (duplo logo)
  sello_peito_lado:       { x: 18,  y: 73 },       // estrela peito "Um de cada lado"
  sello_peito_centro:     { x: 0,   y: 85 },       // estrela peito "Centralizado"
  sello_costas:           { x: 0,   y: 80 },       // estrela costas
  sello_shorts:           { x: 30,  y: -50, r: 4, rx: 1520, ry: 1350 }, // escrita SELLO shorts (r = graus anti-horário; rx/ry = pivô de rotação em coords SVG)
  patrocinadores_frente:  { x: 0,   y: 80 },       // sponsors frente
  patrocinadores_costas:  { x: 0,   y: 60 },       // sponsors costas
};
function gLogoOffset(tipo) {
  return genero === 'fem' ? (LOGO_OFFSET_FEM[tipo] || { x: 0, y: 0 }) : { x: 0, y: 0 };
}
function gEscudoKey() {
  if (posicaoAtual === 'centralizado') return 'escudo_centro';
  if (posicaoAtual === 'duplo_logo')   return 'escudo_duplo';
  return 'escudo_lado';
}

function gUrl(url) {
  if (genero === 'masc') return url;
  return url.replace(/(\.[^./]+)$/, 'FEM$1');
}


const _isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
function mUrlTextura(url) {
  if (!_isMobile) return url;
  return url + (url.includes('?') ? '&' : '?') + 'width=1020';
}

function gUrlCamada(camada) {
  if (genero === 'fem' && camada.arquivoFEM) return camada.arquivoFEM;
  return gUrl(camada.arquivo);
}

function gModelo(url) {
  if (modelo === 'signature') return url;
  return url.replace('camiseta_shorts.', 'camiseta_shortsORIGINAL.');
}

const PARTES = [
  { id: 'tronco',       label: 'Tronco',       arquivo: CDN + 'Tronco.webp' },
  { id: 'manga',        label: 'Mangas',        arquivo: CDN + 'Mangas.webp' },
  { id: 'punho',        label: 'Punhos',        arquivo: CDN + 'Punhos.webp' },
  { id: 'gola',         label: 'Gola',          arquivo: CDN + 'Gola.webp' },
  { id: 'listras',      label: 'Laterais',      arquivo: CDN + 'Listras.webp' },
  { id: 'shorts',       label: 'Shorts',        arquivo: CDN + 'Shorts.webp' },
  { id: 'shortslistra', label: 'Listras',       arquivo: CDN + 'ShortsListras.webp' },
];

let corAtual = GRUPOS_CORES[2].rep; // Branco por padrão
let coresPorParte = {};
let mascaraMangaAtiva = true;
let temEscudo = false;
let temEscudo2 = false;
let logoScale2 = 1.0;
let popoverAberto = null;

// ── COR DOS LOGOS SELLO ──
let corLogoPeitoAtual = null;  // null = automático
let corLogoShortsAtual = null; // null = automático

function getLuminancia(hex) {
  const r = parseInt(hex.slice(1,3),16)/255;
  const g = parseInt(hex.slice(3,5),16)/255;
  const b = parseInt(hex.slice(5,7),16)/255;
  return 0.299*r + 0.587*g + 0.114*b;
}

// Área de referência de cada grupo
function corAreaPeito()  { return coresPorParte['tronco'] || corAtual.hex; }
function corAreaShorts() { return coresPorParte['shorts'] || corAtual.hex; }

function corAutoPeito()  { return getLuminancia(corAreaPeito())  > 0.4 ? '#0a0a0a' : '#ffffff'; }
function corAutoShorts() { return getLuminancia(corAreaShorts()) > 0.4 ? '#0a0a0a' : '#ffffff'; }

function corEfetivaPeito()  { return corLogoPeitoAtual  || corAutoPeito();  }
function corEfetivaShorts() { return corLogoShortsAtual || corAutoShorts(); }

function isProibidoPeito(hex)  { return hex === corAreaPeito();  }
function isProibidoShorts(hex) { return hex === corAreaShorts(); }

// Aplica cor dos logos do peito e costas
function aplicarCorLogosPeito(hex) {
  corLogoPeitoAtual = hex;
  const cor = hex || corAutoPeito();
  ['logo-sello-peito-lado','logo-sello-peito-centro','logo-sello-costas'].forEach(id => {
    const flood = document.getElementById('parte-filter-flood-' + id);
    if (flood) flood.setAttribute('flood-color', cor);
  });
  const btnNone = document.getElementById('logo-peito-btn-none');
  const btnCor  = document.getElementById('logo-peito-btn-cor');
  const nomeEl  = document.getElementById('logo-peito-cor-nome');
  if (btnNone) btnNone.classList.toggle('active', hex === null);
  if (btnCor) {
    btnCor.classList.toggle('active', hex !== null);
    btnCor.style.background = hex !== null
      ? (encontrarTomPorHex(hex)?.tom.hexSwatch || hex)
      : '#e0e0e0';
  }
  if (nomeEl) nomeEl.textContent = hex === null
    ? 'Auto' : (encontrarTomPorHex(hex)?.tom.name || hex);
  document.querySelectorAll('.logo-peito-pop-swatch').forEach(s =>
    s.classList.toggle('active', s.dataset.hex === (hex||'')));
  atualizarPlaceholder();
}

// Aplica cor do logo dos shorts
function aplicarCorLogosShorts(hex) {
  corLogoShortsAtual = hex;
  const cor = hex || corAutoShorts();
  const flood = document.getElementById('parte-filter-flood-logo-sello-shorts');
  if (flood) flood.setAttribute('flood-color', cor);
  const btnNone = document.getElementById('logo-shorts-btn-none');
  const btnCor  = document.getElementById('logo-shorts-btn-cor');
  const nomeEl  = document.getElementById('logo-shorts-cor-nome');
  if (btnNone) btnNone.classList.toggle('active', hex === null);
  if (btnCor) {
    btnCor.classList.toggle('active', hex !== null);
    btnCor.style.background = hex !== null
      ? (encontrarTomPorHex(hex)?.tom.hexSwatch || hex)
      : '#e0e0e0';
  }
  if (nomeEl) nomeEl.textContent = hex === null
    ? 'Auto' : (encontrarTomPorHex(hex)?.tom.name || hex);
  document.querySelectorAll('.logo-shorts-pop-swatch').forEach(s =>
    s.classList.toggle('active', s.dataset.hex === (hex||'')));
}

function atualizarPlaceholder() {
  const cor = corEfetivaPeito();
  const c = cor === '#ffffff' || cor === '#f5f5f5' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.4)';
  const svgStr = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110">
  <rect x="3" y="3" width="104" height="104" rx="12"
    fill="rgba(128,128,128,0.08)"
    stroke="${c}"
    stroke-width="3"
    stroke-dasharray="8 5"/>
  <text x="55" y="42" text-anchor="middle"
    font-family="Arial,sans-serif" font-size="28"
    fill="${c}">⬆</text>
  <text x="55" y="68" text-anchor="middle"
    font-family="Arial,sans-serif" font-size="11"
    font-weight="700" letter-spacing="1"
    fill="${c}">SEU LOGO</text>
</svg>`;
  const href = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgStr);
  const el = document.getElementById('logo-placeholder');
  if (el) el.setAttribute('href', href);
  const el2 = document.getElementById('logo-placeholder-2');
  if (el2) el2.setAttribute('href', href);
}

function atualizarLogoAuto() {
  // Peito: se cor atual ficou proibida, volta para auto
  if (corLogoPeitoAtual !== null && isProibidoPeito(corLogoPeitoAtual))
    aplicarCorLogosPeito(null);
  else
    aplicarCorLogosPeito(corLogoPeitoAtual);
  // Shorts: idem
  if (corLogoShortsAtual !== null && isProibidoShorts(corLogoShortsAtual))
    aplicarCorLogosShorts(null);
  else
    aplicarCorLogosShorts(corLogoShortsAtual);
}

// ── COR DO LOGO CLIENTE ──
let corLogoCliente = null;
let corLogo2 = null;

function aplicarCorLogoCliente(hex) {
  corLogoCliente = hex;
  const el = document.getElementById('logo-cliente');
  if (!el) return;

  // Remove filtro SVG anterior se existir
  const svgRoot = el.closest('svg');
  const FILTER_ID = 'sello-logo-color-filter';
  const existing = document.getElementById(FILTER_ID);
  if (existing) existing.remove();
  el.removeAttribute('filter');

  if (hex === null) {
    if (el._originalHref) el.setAttribute('href', el._originalHref);
    // Atualiza botões mesmo no reset
    const _bN = document.getElementById('logo-cliente-btn-none');
    const _bC = document.getElementById('logo-cliente-btn-cor');
    const _nm = document.getElementById('logo-cliente-cor-nome');
    if (_bN) _bN.classList.add('active');
    if (_bC) { _bC.classList.remove('active'); _bC.style.background = '#e0e0e0'; }
    if (_nm) _nm.textContent = 'Original';
    const _sBN = document.getElementById('escudo-sec-btn-none');
    const _sBC = document.getElementById('escudo-sec-btn-cor');
    if (_sBN) _sBN.classList.add('active');
    if (_sBC) { _sBC.classList.remove('active'); _sBC.style.background = '#e0e0e0'; }
    return;
  }

  const currentHref = el.getAttribute('href');
  if (currentHref && !currentHref.startsWith('data:image/svg')) {
    if (!el._originalHref) el._originalHref = currentHref;
  }

  const srcHref = el._originalHref || currentHref;
  if (!srcHref) return;

  // Primeiro tenta via filtro SVG (funciona para PNGs com fundo transparente,
  // qualquer cor de logo — preto, branco, colorido)
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width || 1;
    canvas.height = img.height || 1;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    let imageData;
    try { imageData = ctx.getImageData(0, 0, canvas.width, canvas.height); }
    catch(e) { imageData = null; }

    const data = imageData ? imageData.data : null;

    // Detecta se tem fundo transparente
    let hasTransparency = false;
    if (data) {
      for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 200) { hasTransparency = true; break; }
      }
    }

    if (hasTransparency || !data) {
      if (!data) return; // canvas bloqueado, sem fallback
      // PNG transparente: tinting por luminosidade, preserva tons e alpha
      // Detecta se a tinta é escura ou clara (amostrando só pixels opacos)
      let totalLum = 0, count = 0;
      for (let i = 0; i < data.length; i += 4) {
        if (data[i+3] > 128) {
          totalLum += (0.299*data[i] + 0.587*data[i+1] + 0.114*data[i+2]) / 255;
          count++;
        }
      }
      const inkIsDark = count > 0 && (totalLum / count) < 0.5;
      const tr = parseInt(hex.slice(1,3),16);
      const tg = parseInt(hex.slice(3,5),16);
      const tb = parseInt(hex.slice(5,7),16);
      for (let i = 0; i < data.length; i += 4) {
        if (data[i+3] === 0) continue;
        const lum = (0.299*data[i] + 0.587*data[i+1] + 0.114*data[i+2]) / 255;
        // Logo escuro: pixels mais escuros = tinta cheia → mask = 1 - lum
        // Logo claro:  pixels mais claros  = tinta cheia → mask = lum
        const mask = inkIsDark ? (1 - lum) : lum;
        data[i]   = Math.round(tr * mask);
        data[i+1] = Math.round(tg * mask);
        data[i+2] = Math.round(tb * mask);
        // alpha inalterado — preserva forma, bordas e variações de opacidade
      }
      ctx.putImageData(imageData, 0, 0);
      el.setAttribute('href', canvas.toDataURL('image/png'));
    } else {
      // JPEG / PNG fundo sólido: canvas pixel manipulation
      const tr = parseInt(hex.slice(1,3),16);
      const tg = parseInt(hex.slice(3,5),16);
      const tb = parseInt(hex.slice(5,7),16);
      for (let i = 0; i < data.length; i += 4) {
        if (data[i+3] === 0) continue;
        const lum = (0.299*data[i] + 0.587*data[i+1] + 0.114*data[i+2]) / 255;
        data[i]   = tr;
        data[i+1] = tg;
        data[i+2] = tb;
        data[i+3] = Math.round(255 * (1 - lum));
      }
      ctx.putImageData(imageData, 0, 0);
      el.setAttribute('href', canvas.toDataURL('image/png'));
    }
  };
  img.src = srcHref;

  const btnNone = document.getElementById('logo-cliente-btn-none');
  const btnCor  = document.getElementById('logo-cliente-btn-cor');
  const nomeEl  = document.getElementById('logo-cliente-cor-nome');
  if (btnNone) btnNone.classList.toggle('active', hex === null);
  if (btnCor) {
    btnCor.classList.toggle('active', hex !== null);
    btnCor.style.background = hex !== null
      ? (encontrarTomPorHex(hex)?.tom.hexSwatch || hex)
      : '#e0e0e0';
  }
  if (nomeEl) {
    nomeEl.textContent = hex === null
      ? 'Original'
      : (encontrarTomPorHex(hex)?.tom.name || hex);
  }
  document.querySelectorAll('.logo-cliente-pop-swatch').forEach(s => {
    s.classList.toggle('active', s.dataset.hex === (hex||''));
  });
  // Sincroniza picker secundário no escudo section
  const escBtnCor  = document.getElementById('escudo-sec-btn-cor');
  const escBtnNone = document.getElementById('escudo-sec-btn-none');
  if (escBtnCor) {
    escBtnCor.classList.toggle('active', hex !== null);
    escBtnCor.style.background = hex !== null ? (encontrarTomPorHex(hex)?.tom.hexSwatch || hex) : '#e0e0e0';
  }
  if (escBtnNone) escBtnNone.classList.toggle('active', hex === null);
}

// ── COR BASE ──
function buildCores() {
  const wrap = document.getElementById('color-swatches');
  wrap.innerHTML = '';

  const popover = document.getElementById('color-base-popover');
  let grupoAberto = null;

  function fecharPopoverBase() {
    popover.classList.remove('open');
    popover.innerHTML = '';
    wrap.querySelectorAll('.swatch').forEach(s => s.classList.remove('group-open'));
    grupoAberto = null;
  }

  GRUPOS_CORES.forEach(g => {
    const s = document.createElement('div');
    s.className = 'swatch';
    s.style.background = g.rep.hexSwatch || g.rep.hex;
    s.style.setProperty('--swatch-color', g.rep.hexSwatch || g.rep.hex);
    s.title = g.rep.name;
    applySwatchShadow(s, g.rep.hexSwatch || g.rep.hex);
    if (corAtual.hex && g.tons.some(t => t.hex === corAtual.hex)) s.classList.add('group-selected');

    s.onclick = e => {
      e.stopPropagation();
      triggerSwatchClick(s);

      if (grupoAberto === g) { fecharPopoverBase(); return; }

      grupoAberto = g;
      wrap.querySelectorAll('.swatch').forEach(x => x.classList.remove('group-open', 'group-selected'));
      if (corAtual.hex && g.tons.some(t => t.hex === corAtual.hex)) s.classList.add('group-selected');
      s.classList.add('group-open');

      popover.innerHTML = '';
      g.tons.forEach(tom => {
        const ts = document.createElement('div');
        ts.className = 'swatch';
        ts.style.background = tom.hexSwatch || tom.hex;
        ts.style.setProperty('--swatch-color', tom.hexSwatch || tom.hex);
        ts.title = tom.name;
        ts.dataset.hex = tom.hex;
        applySwatchShadow(ts, tom.hexSwatch || tom.hex);
        if (corAtual.hex === tom.hex) ts.classList.add('active');

        ts.onclick = e2 => {
          e2.stopPropagation();
          triggerSwatchClick(ts);
          popover.querySelectorAll('.swatch').forEach(x => x.classList.remove('active'));
          ts.classList.add('active');
          wrap.querySelectorAll('.swatch').forEach(x => x.classList.remove('group-selected'));
          s.classList.add('group-selected');
          s.style.background = tom.hexSwatch || tom.hex;
          s.style.setProperty('--swatch-color', tom.hexSwatch || tom.hex);
          applySwatchShadow(s, tom.hexSwatch || tom.hex);
          corAtual = tom;
          const flood = document.getElementById('parte-filter-flood-geral');
          if (flood) flood.setAttribute('flood-color', tom.hex);
          document.getElementById('color-name-label').textContent = tom.name;
          atualizarLogoAuto();
          if (!coresPorParte['tronco']) aplicarHalftoneTronco();
          fecharPopoverBase();
        };
        popover.appendChild(ts);
      });
      popover.classList.add('open');
    };
    wrap.appendChild(s);
  });

}

document.addEventListener('click', e => {
  if (!e.target.closest('.color-swatches-wrapper')) {
    const popover = document.getElementById('color-base-popover');
    if (popover) {
      popover.classList.remove('open');
      popover.innerHTML = '';
      const wrap = document.getElementById('color-swatches');
      if (wrap) wrap.querySelectorAll('.swatch').forEach(s => s.classList.remove('group-open'));
    }
  }
});

// ── PARTES ──
function fecharPopovers() {
  document.querySelectorAll('.color-picker-popover.open').forEach(p=>p.classList.remove('open'));
  popoverAberto = null;
  const bd = document.getElementById('mobile-popover-backdrop');
  if (bd) bd.classList.remove('open');
}

function abrirPopover(popover) {
  popover.classList.add('open');
  if (window.innerWidth < 750) {
    const bd = document.getElementById('mobile-popover-backdrop');
    if (bd) bd.classList.add('open');
  }
}

document.addEventListener('click', e => {
  if (!e.target.closest('.parte-wrapper')) fecharPopovers();
});

const PARTES_ICONES = {
  tronco:       CDN + 'IconeTronco.webp',
  manga:        CDN + 'IconeMangas.webp',
  punho:        CDN + 'IconePunhos.webp',
  gola:         CDN + 'IconeGola.webp',
  listras:      CDN + 'IconeLaterais.webp',
  shorts:       CDN + 'IconeShorts.webp',
  shortslistra: CDN + 'IconeListras.webp',
};

function buildPartes() {
  const list = document.getElementById('partes-list');
  list.innerHTML = '';

  PARTES.forEach(parte => {
    const item = document.createElement('div');
    item.className = 'parte-item';

    const esquerda = document.createElement('div');
    esquerda.className = 'parte-esquerda';

    const icone = document.createElement('img');
    icone.className = 'parte-icone';
    icone.src = PARTES_ICONES[parte.id] || '';
    icone.alt = parte.label;
    esquerda.appendChild(icone);

    const label = document.createElement('span');
    label.className = 'parte-label';
    label.textContent = parte.label;
    esquerda.appendChild(label);
    item.appendChild(esquerda);

    const btns = document.createElement('div');
    btns.className = 'parte-btns';

    const wrapper = document.createElement('div');
    wrapper.className = 'parte-wrapper';
    wrapper.style.position = 'relative';

    const btnCor = document.createElement('div');
    btnCor.className = 'parte-btn-cor';
    btnCor.style.background = '#e0e0e0';
    btnCor.title = 'Escolher cor';

    const popover = document.createElement('div');
    popover.className = 'color-picker-popover';
    const popTitle = document.createElement('div');
    popTitle.className = 'popover-title';
    popTitle.textContent = parte.label;

    const { groupRow: popGroupRow, toneRow: popToneRow, reset: resetPopover } = criarSeletorCores({
      groupClass: 'pop-swatch',
      toneClass: 'pop-swatch',
      getHexAtivo: () => coresPorParte[parte.id],
      isProibido: null,
      onSelectTom: tom => {
        coresPorParte[parte.id] = tom.hex;
        const flood = document.getElementById('parte-filter-flood-' + parte.id);
        const img   = document.getElementById('parte-webp-' + parte.id);
        if (flood) flood.setAttribute('flood-color', tom.hex);
        if (img) {
          const jaVisivel = img.style.display !== 'none' && img.style.opacity !== '0';
          if (jaVisivel) {
            img.style.transition = '';
            img.style.opacity = '';
          } else {
            img.style.display = '';
            img.style.transition = 'none';
            img.style.opacity = '0';
            void img.getBoundingClientRect();
            img.style.transition = 'opacity 0.4s cubic-bezier(0.22,1,0.36,1)';
            img.style.opacity = '1';
            setTimeout(() => { img.style.transition = ''; img.style.opacity = ''; }, 420);
          }
        }
        btnCor.style.background = tom.hexSwatch || tom.hex;
        btnCor.classList.add('active');
        btnNone.classList.remove('active');
        nomeSpan.textContent = tom.name;
        if (parte.id === 'tronco' || parte.id === 'shorts') { atualizarLogoAuto(); atualizarPlaceholder(); }
        if (parte.id === 'tronco' || parte.id === 'manga') aplicarHalftoneTronco();
        fecharPopovers();
      }
    });
    popGroupRow.className += ' popover-swatches';
    popToneRow.className += ' popover-tones';

    popover.appendChild(popTitle);
    popover.appendChild(popGroupRow);
    popover.appendChild(popToneRow);

    btnCor.onclick = e => {
      e.stopPropagation();
      const jaAberto = popover.classList.contains('open');
      fecharPopovers();
      if (!jaAberto) { resetPopover(); abrirPopover(popover); popoverAberto = popover; }
    };

    wrapper.appendChild(btnCor);
    wrapper.appendChild(popover);

    const btnNone = document.createElement('div');
    btnNone.className = 'parte-btn-none active';
    btnNone.title = 'Sem cor (usar cor base)';
    btnNone.onclick = () => {
      coresPorParte[parte.id] = null;
      const img = document.getElementById('parte-webp-' + parte.id);
      if (img) {
        img.style.transition = 'opacity 0.4s cubic-bezier(0.22,1,0.36,1)';
        img.style.opacity = '0';
        setTimeout(() => { img.style.display = 'none'; img.style.transition = ''; img.style.opacity = ''; }, 420);
      }
      btnCor.style.background = '#e0e0e0';
      btnCor.classList.remove('active');
      btnNone.classList.add('active');
      nomeSpan.textContent = '—';
      if (parte.id === 'tronco' || parte.id === 'shorts') { atualizarLogoAuto(); atualizarPlaceholder(); }
      if (parte.id === 'tronco' || parte.id === 'manga') aplicarHalftoneTronco();
    };

    const nomeSpan = document.createElement('span');
    nomeSpan.className = 'parte-cor-nome';
    nomeSpan.textContent = '—';

    btns.appendChild(nomeSpan);
    btns.appendChild(wrapper);
    btns.appendChild(btnNone);
    item.appendChild(btns);
    list.appendChild(item);
  });

  // ── helper para criar linha de logo ──
  function criarLinhaLogo(labelTxt, btnCorId, btnNoneId, nomeId, popSwatchClass, isProibidoFn, aplicarFn, iconeUrl) {
    const item = document.createElement('div');
    item.className = 'parte-item';
    const esquerda = document.createElement('div');
    esquerda.className = 'parte-esquerda';
    if (iconeUrl) {
      const icone = document.createElement('img');
      icone.className = 'parte-icone';
      icone.src = iconeUrl; icone.alt = labelTxt;
      esquerda.appendChild(icone);
    }
    const lbl = document.createElement('span');
    lbl.className = 'parte-label';
    lbl.textContent = labelTxt;
    esquerda.appendChild(lbl);
    item.appendChild(esquerda);
    const btns = document.createElement('div');
    btns.className = 'parte-btns';
    const wrapper = document.createElement('div');
    wrapper.className = 'parte-wrapper';
    const btnCor = document.createElement('div');
    btnCor.id = btnCorId;
    btnCor.className = 'parte-btn-cor';
    btnCor.style.background = '#e0e0e0';
    btnCor.title = 'Escolher cor';
    const popover = document.createElement('div');
    popover.className = 'color-picker-popover';
    const popTitle = document.createElement('div');
    popTitle.className = 'popover-title';
    popTitle.textContent = labelTxt;
    const { groupRow: lgGroupRow, toneRow: lgToneRow, reset: resetLg } = criarSeletorCores({
      groupClass: 'pop-swatch ' + popSwatchClass,
      toneClass: 'pop-swatch ' + popSwatchClass,
      getHexAtivo: () => null,
      isProibido: hex => isProibidoFn(hex),
      onSelectTom: tom => {
        aplicarFn(tom.hex);
        fecharPopovers();
      }
    });
    lgGroupRow.className += ' popover-swatches';
    lgToneRow.className += ' popover-tones';
    popover.appendChild(popTitle);
    popover.appendChild(lgGroupRow);
    popover.appendChild(lgToneRow);
    btnCor.onclick = e => {
      e.stopPropagation();
      const jaAberto = popover.classList.contains('open');
      fecharPopovers();
      if (!jaAberto) { resetLg(); abrirPopover(popover); }
    };
    wrapper.appendChild(btnCor);
    wrapper.appendChild(popover);
    const btnNone = document.createElement('div');
    btnNone.id = btnNoneId;
    btnNone.className = 'parte-btn-none active';
    btnNone.title = 'Automático';
    btnNone.onclick = () => aplicarFn(null);
    const nome = document.createElement('span');
    nome.className = 'parte-cor-nome';
    nome.id = nomeId;
    nome.textContent = 'Auto';
    btns.appendChild(nome);
    btns.appendChild(wrapper);
    btns.appendChild(btnNone);
    item.appendChild(btns);
    list.appendChild(item);
  }

  // Logos Sello — Peito & Costas
  criarLinhaLogo(
    'Logos Sello (peito)',
    'logo-peito-btn-cor', 'logo-peito-btn-none', 'logo-peito-cor-nome',
    'logo-peito-pop-swatch',
    isProibidoPeito, aplicarCorLogosPeito,
    CDN + 'IconeSelloPeito.webp'
  );

  // Logos Sello — Shorts
  criarLinhaLogo(
    'Logos Sello (shorts)',
    'logo-shorts-btn-cor', 'logo-shorts-btn-none', 'logo-shorts-cor-nome',
    'logo-shorts-pop-swatch',
    isProibidoShorts, aplicarCorLogosShorts,
    CDN + 'IconeSelloShorts.webp'
  );

  // ── Cor do logo do cliente ──
  const logoClienteItem = document.createElement('div');
  logoClienteItem.className = 'parte-item';
  logoClienteItem.id = 'logo-cliente-row';

  const logoClienteEsquerda = document.createElement('div');
  logoClienteEsquerda.className = 'parte-esquerda';
  const logoClienteIcone = document.createElement('img');
  logoClienteIcone.className = 'parte-icone';
  logoClienteIcone.src = CDN + 'IconeSeuEscudo.webp';
  logoClienteIcone.alt = 'Cor do seu logo';
  logoClienteEsquerda.appendChild(logoClienteIcone);
  const logoClienteLabel = document.createElement('span');
  logoClienteLabel.className = 'parte-label';
  logoClienteLabel.textContent = 'Seu Logo';
  logoClienteEsquerda.appendChild(logoClienteLabel);

  const logoClienteAviso = document.createElement('span');
  logoClienteAviso.id = 'logo-cliente-aviso';
  logoClienteAviso.className = 'parte-cor-nome';
  logoClienteAviso.style.cssText = 'color:#bbb;font-style:italic;font-size:1.1rem;';
  logoClienteAviso.textContent = 'Faça o upload do seu escudo primeiro';

  const logoClienteBtns = document.createElement('div');
  logoClienteBtns.className = 'parte-btns';
  logoClienteBtns.id = 'logo-cliente-btns';
  logoClienteBtns.style.display = 'none';

  const logoClienteWrapper = document.createElement('div');
  logoClienteWrapper.className = 'parte-wrapper';

  const logoClienteBtnCor = document.createElement('div');
  logoClienteBtnCor.id = 'logo-cliente-btn-cor';
  logoClienteBtnCor.className = 'parte-btn-cor';
  logoClienteBtnCor.style.background = '#e0e0e0';
  logoClienteBtnCor.title = 'Escolher cor';

  const logoClientePopover = document.createElement('div');
  logoClientePopover.className = 'color-picker-popover';
  const logoClientePopTitle = document.createElement('div');
  logoClientePopTitle.className = 'popover-title';
  logoClientePopTitle.textContent = 'Cor do seu logo';
  const { groupRow: lcGroupRow, toneRow: lcToneRow, reset: resetLc } = criarSeletorCores({
    groupClass: 'pop-swatch logo-cliente-pop-swatch',
    toneClass: 'pop-swatch logo-cliente-pop-swatch',
    getHexAtivo: () => corLogoCliente,
    isProibido: null,
    onSelectTom: tom => {
      aplicarCorLogoCliente(tom.hex);
      fecharPopovers();
    }
  });
  lcGroupRow.className += ' popover-swatches';
  lcToneRow.className += ' popover-tones';

  logoClientePopover.appendChild(logoClientePopTitle);
  logoClientePopover.appendChild(lcGroupRow);
  logoClientePopover.appendChild(lcToneRow);

  logoClienteBtnCor.onclick = e => {
    e.stopPropagation();
    const jaAberto = logoClientePopover.classList.contains('open');
    fecharPopovers();
    if (!jaAberto) { resetLc(); abrirPopover(logoClientePopover); }
  };

  logoClienteWrapper.appendChild(logoClienteBtnCor);
  logoClienteWrapper.appendChild(logoClientePopover);

  const logoClienteBtnNone = document.createElement('div');
  logoClienteBtnNone.id = 'logo-cliente-btn-none';
  logoClienteBtnNone.className = 'parte-btn-none active';
  logoClienteBtnNone.title = 'Cores originais do logo';
  logoClienteBtnNone.onclick = () => aplicarCorLogoCliente(null);

  const logoClienteNome = document.createElement('span');
  logoClienteNome.className = 'parte-cor-nome';
  logoClienteNome.id = 'logo-cliente-cor-nome';
  logoClienteNome.textContent = '';

  logoClienteBtns.appendChild(logoClienteNome);
  logoClienteBtns.appendChild(logoClienteWrapper);
  logoClienteBtns.appendChild(logoClienteBtnNone);
  logoClienteItem.appendChild(logoClienteEsquerda);
  logoClienteItem.appendChild(logoClienteAviso);
  logoClienteItem.appendChild(logoClienteBtns);
  list.appendChild(logoClienteItem);

  // Picker secundário no escudo section (sincronizado)
  const escudoCor = document.getElementById('escudo-cor-container');
  if (escudoCor) {
    const escWrap = document.createElement('div');
    escWrap.className = 'parte-wrapper';
    escWrap.style.position = 'relative';

    const escBtnCor = document.createElement('div');
    escBtnCor.id = 'escudo-sec-btn-cor';
    escBtnCor.className = 'parte-btn-cor';
    escBtnCor.style.background = '#e0e0e0';
    escBtnCor.title = 'Cor do logo';

    const escPop = document.createElement('div');
    escPop.className = 'color-picker-popover';
    const escPopTitle = document.createElement('div');
    escPopTitle.className = 'popover-title';
    escPopTitle.textContent = 'Cor do seu logo';
    const { groupRow: escGR, toneRow: escTR, reset: escReset } = criarSeletorCores({
      groupClass: 'pop-swatch', toneClass: 'pop-swatch',
      getHexAtivo: () => corLogoCliente, isProibido: null,
      onSelectTom: tom => { aplicarCorLogoCliente(tom.hex); fecharPopovers(); }
    });
    escGR.className += ' popover-swatches';
    escTR.className += ' popover-tones';
    escPop.appendChild(escPopTitle); escPop.appendChild(escGR); escPop.appendChild(escTR);
    escBtnCor.onclick = e => {
      e.stopPropagation();
      const jaAberto = escPop.classList.contains('open');
      fecharPopovers();
      if (!jaAberto) { escReset(); abrirPopover(escPop); }
    };
    escWrap.appendChild(escBtnCor);
    escWrap.appendChild(escPop);

    const escBtnNone = document.createElement('div');
    escBtnNone.id = 'escudo-sec-btn-none';
    escBtnNone.className = 'parte-btn-none active';
    escBtnNone.title = 'Cores originais';
    escBtnNone.onclick = () => aplicarCorLogoCliente(null);

    escudoCor.appendChild(escWrap);
    escudoCor.appendChild(escBtnNone);
  }
}


// ── ESCUDO ──
let logoScale = 1.0;
const LOGO_SCALE_STEP = 0.1;
const LOGO_SCALE_MIN = 0.5;
const LOGO_SCALE_MAX = 1.5;
const LOGO_BASE_MULTIPLIER = 1.4;

function resizeLogo(dir) {
  logoScale = Math.min(LOGO_SCALE_MAX, Math.max(LOGO_SCALE_MIN, logoScale + dir * LOGO_SCALE_STEP));
  applyLogoScale();
  document.getElementById('logo-size-label').textContent = Math.round(logoScale * 100) + '%';
}

function applyLogoScale() {
  const p = LOGO_POSICOES[posicaoAtual];
  const [bx, by, bw, bh] = p.placeholder;
  const off = gLogoOffset(gEscudoKey());
  const cx = bx + bw / 2;
  const cy = by + bh / 2 + off.y;
  const nw = Math.round(bw * LOGO_BASE_MULTIPLIER * logoScale);
  const nh = Math.round(bh * LOGO_BASE_MULTIPLIER * logoScale);
  const el = document.getElementById('logo-cliente');
  if (el) {
    el.setAttribute('x', Math.round(cx - nw / 2 + off.x));
    el.setAttribute('y', Math.round(cy - nh / 2));
    el.setAttribute('width', nw);
    el.setAttribute('height', nh);
  }
}

async function removeBgCanvas(dataUrl) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      const w = canvas.width;
      const h = canvas.height;
      const bgR = data[0], bgG = data[1], bgB = data[2];
      const tolerance = 30;
      function colorMatch(idx) {
        return Math.abs(data[idx]-bgR) < tolerance &&
               Math.abs(data[idx+1]-bgG) < tolerance &&
               Math.abs(data[idx+2]-bgB) < tolerance;
      }
      const visited = new Uint8Array(w * h);
      const queue = [];
      [[0,0],[w-1,0],[0,h-1],[w-1,h-1]].forEach(([x,y]) => {
        const idx4 = (y * w + x) * 4;
        if (colorMatch(idx4)) queue.push(y * w + x);
      });
      while (queue.length > 0) {
        const pos = queue.pop();
        if (visited[pos]) continue;
        visited[pos] = 1;
        const idx4 = pos * 4;
        if (!colorMatch(idx4)) continue;
        data[idx4+3] = 0;
        const x = pos % w;
        const y = Math.floor(pos / w);
        if (x > 0)   queue.push(pos - 1);
        if (x < w-1) queue.push(pos + 1);
        if (y > 0)   queue.push(pos - w);
        if (y < h-1) queue.push(pos + w);
      }
      ctx.putImageData(imageData, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.src = dataUrl;
  });
}

// Verifica se um dataUrl já tem pixels transparentes (não precisa de removeBgCanvas)
function jaTemTransparencia(dataUrl) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 250) { resolve(true); return; }
      }
      resolve(false);
    };
    img.onerror = () => resolve(false);
    img.src = dataUrl;
  });
}

document.getElementById('file-input').addEventListener('change', async function(e) {
  const file = e.target.files[0];
  if (!file) return;
  const uploadZone = document.getElementById('upload-zone');
  uploadZone.innerHTML = '<span style="color:#888;font-size:1.2rem;">⏳ Removendo fundo...</span>';
  uploadZone.style.pointerEvents = 'none';
  try {
    const dataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = ev => resolve(ev.target.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
    // Só remove fundo se a imagem NÃO tiver transparência nativa
    // (evita apagar logos pretos, que têm RGB 0,0,0 igual ao fundo transparente do canvas)
    const _bgRemoved = await jaTemTransparencia(dataUrl) ? dataUrl : await removeBgCanvas(dataUrl);
    const finalDataUrl = await trimTransparencia(_bgRemoved);
    const cliente = document.getElementById('logo-cliente');
    const placeholder = document.getElementById('logo-placeholder');
    cliente.setAttribute('href', finalDataUrl);
    cliente.style.display = '';
    placeholder.style.display = 'none';
    temEscudo = true;
    logoScale = 1.0;
    document.getElementById('logo-size-label').textContent = '100%';
    applyLogoScale();
    document.getElementById('logo-size-controls').classList.add('visible');
    document.getElementById('escudo-status').style.display = 'flex';
    document.getElementById('upload-zone').style.display = 'none';
    const previewImg = document.getElementById('upload-preview-img');
    if (previewImg) { previewImg.src = finalDataUrl; }
    const previewNome = document.getElementById('upload-preview-nome');
    if (previewNome) previewNome.textContent = file.name;
    const aviso = document.getElementById('logo-cliente-aviso');
    if (aviso) aviso.style.display = 'none';
    const btnsCliente = document.getElementById('logo-cliente-btns');
    if (btnsCliente) btnsCliente.style.display = '';
  } catch(err) {
    console.error('Erro ao processar logo:', err);
  } finally {
    const zone = document.getElementById('upload-zone');
    zone.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg><span class="upload-zone-titulo">Clique para fazer upload</span><span class="upload-zone-sub">PNG ou JPG — preferencialmente com fundo transparente</span>';
    zone.style.pointerEvents = '';
  }
});

function removerEscudo() {
  const cliente = document.getElementById('logo-cliente');
  const placeholder = document.getElementById('logo-placeholder');
  cliente.removeAttribute('href');
  cliente.style.display = 'none';
  placeholder.style.display = '';
  temEscudo = false;
  logoScale = 1.0;
  document.getElementById('logo-size-controls').classList.remove('visible');
  document.getElementById('logo-size-label').textContent = '100%';
  document.getElementById('escudo-status').style.display = 'none';
  document.getElementById('upload-zone').style.display = '';
  const previewImg = document.getElementById('upload-preview-img');
  if (previewImg) previewImg.src = '';
  document.getElementById('file-input').value = '';
  if (cliente) cliente._originalHref = null;
  aplicarCorLogoCliente(null);
  const aviso2 = document.getElementById('logo-cliente-aviso');
  if (aviso2) aviso2.style.display = '';
  const btnsCliente2 = document.getElementById('logo-cliente-btns');
  if (btnsCliente2) btnsCliente2.style.display = 'none';
  const nomeCliente = document.getElementById('logo-cliente-cor-nome');
  if (nomeCliente) nomeCliente.textContent = '';
}

function applyLogoScale2() {
  const p2 = LOGO_POSICOES.duplo_logo.placeholder2;
  const [bx, by, bw, bh] = p2;
  const off = gLogoOffset('escudo2');
  const cx = bx + bw / 2 + off.x;
  const cy = by + bh / 2 + off.y;
  const nw = Math.round(bw * LOGO_BASE_MULTIPLIER * logoScale2);
  const nh = Math.round(bh * LOGO_BASE_MULTIPLIER * logoScale2);
  const el = document.getElementById('logo-cliente-2');
  if (el) {
    el.setAttribute('x', Math.round(cx - nw / 2));
    el.setAttribute('y', Math.round(cy - nh / 2));
    el.setAttribute('width', nw);
    el.setAttribute('height', nh);
  }
}

function resizeLogo2(delta) {
  logoScale2 = Math.max(0.3, Math.min(3.0, logoScale2 + delta * 0.1));
  const label = document.getElementById('logo2-size-label');
  if (label) label.textContent = Math.round(logoScale2 * 100) + '%';
  applyLogoScale2();
}

function removerEscudo2() {
  const el = document.getElementById('logo-cliente-2');
  const ph = document.getElementById('logo-placeholder-2');
  if (el) { el.removeAttribute('href'); el.style.display = 'none'; el._originalHref = null; }
  if (ph) ph.style.display = '';
  temEscudo2 = false;
  logoScale2 = 1.0;
  corLogo2 = null;
  document.getElementById('escudo2-status').style.display = 'none';
  document.getElementById('upload-zone-2').style.display = '';
  document.getElementById('file-input-2').value = '';
  const lbl = document.getElementById('logo2-size-label');
  if (lbl) lbl.textContent = '100%';
}

async function aplicarCorLogo2(hex) {
  corLogo2 = hex;
  const el = document.getElementById('logo-cliente-2');
  if (!el) return;
  const src = el._originalHref;
  if (!src) return;
  if (hex === null) {
    el.setAttribute('href', src);
  } else {
    el.setAttribute('href', await tintarImagem(src, hex));
  }
  const btnNone = document.getElementById('logo2-btn-none');
  const btnCor  = document.getElementById('logo2-btn-cor');
  if (btnNone) btnNone.classList.toggle('active', hex === null);
  if (btnCor) {
    btnCor.classList.toggle('active', hex !== null);
    btnCor.style.background = hex !== null ? (encontrarTomPorHex(hex)?.tom.hexSwatch || hex) : '#e0e0e0';
  }
}

function buildCorLogo2() {
  const container = document.getElementById('logo2-cor-container');
  if (!container || container._built) return;
  container._built = true;

  const btnNone = document.createElement('div');
  btnNone.className = 'parte-btn-none active';
  btnNone.id = 'logo2-btn-none';
  btnNone.title = 'Cores originais';
  btnNone.onclick = () => { aplicarCorLogo2(null); fecharPopovers(); };

  const btnCor = document.createElement('div');
  btnCor.className = 'parte-btn-cor';
  btnCor.id = 'logo2-btn-cor';
  btnCor.style.background = '#e0e0e0';
  btnCor.title = 'Colorir logo';

  const popover = document.createElement('div');
  popover.className = 'color-picker-popover';
  const popTitle = document.createElement('div');
  popTitle.className = 'popover-title';
  popTitle.textContent = 'Cor do segundo logo';
  const { groupRow, toneRow, reset: resetPop } = criarSeletorCores({
    groupClass: 'pop-swatch', toneClass: 'pop-swatch',
    getHexAtivo: () => corLogo2, isProibido: null,
    onSelectTom: tom => { aplicarCorLogo2(tom.hex); fecharPopovers(); }
  });
  groupRow.className += ' popover-swatches';
  toneRow.className += ' popover-tones';
  popover.appendChild(popTitle); popover.appendChild(groupRow); popover.appendChild(toneRow);

  btnCor.onclick = e => {
    e.stopPropagation();
    const jaAberto = popover.classList.contains('open');
    fecharPopovers();
    if (!jaAberto) { resetPop(); abrirPopover(popover); }
  };

  const wrap = document.createElement('div');
  wrap.className = 'parte-wrapper';
  wrap.style.position = 'relative';
  wrap.appendChild(btnCor);
  wrap.appendChild(popover);
  container.appendChild(wrap);
  container.appendChild(btnNone);
}

const fi2 = document.getElementById('file-input-2');
if (fi2) fi2.addEventListener('change', async function(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async ev => {
      const dataUrl = ev.target.result;
      const _bgRemoved = await jaTemTransparencia(dataUrl) ? dataUrl : await removeBgCanvas(dataUrl);
      const finalDataUrl = await trimTransparencia(_bgRemoved);
      const el = document.getElementById('logo-cliente-2');
      const ph = document.getElementById('logo-placeholder-2');
      el.setAttribute('href', finalDataUrl);
      el._originalHref = finalDataUrl;
      el.style.display = '';
      if (ph) ph.style.display = 'none';
      temEscudo2 = true;
      logoScale2 = 1.0;
      const lbl = document.getElementById('logo2-size-label');
      if (lbl) lbl.textContent = '100%';
      applyLogoScale2();
      document.getElementById('escudo2-status').style.display = 'flex';
      document.getElementById('upload-zone-2').style.display = 'none';
      const previewImg = document.getElementById('upload-preview-img-2');
      if (previewImg) previewImg.src = finalDataUrl;
      const previewNome = document.getElementById('upload-preview-nome-2');
      if (previewNome) previewNome.textContent = file.name;
    };
    reader.readAsDataURL(file);
});

async function salvarModelo() {
  const btn = document.getElementById('btn-salvar');
  const btnLabel = '<svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg> Salvar modelo';
  btn.classList.add('loading');
  btn.innerHTML = '⏳ Gerando...';

  try {
    const vbW = 2040, vbH = 1734;
    const canvas = document.createElement('canvas');
    canvas.width = vbW; canvas.height = vbH;
    const ctx = canvas.getContext('2d');

    function hexToRgb(hex) {
      return [parseInt(hex.slice(1,3),16), parseInt(hex.slice(3,5),16), parseInt(hex.slice(5,7),16)];
    }

    function loadImg(url) {
      return new Promise((res, rej) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => res(img);
        img.onerror = rej;
        img.src = url;
      });
    }

    // Desenha WebP com cor sólida aplicada via alpha (equivale a feFlood+feComposite)
    async function drawColor(url, hex) {
      let img; try { img = await loadImg(url); } catch(e) { return; }
      const off = document.createElement('canvas');
      off.width = vbW; off.height = vbH;
      const octx = off.getContext('2d');
      octx.drawImage(img, 0, 0, vbW, vbH);
      const id = octx.getImageData(0, 0, vbW, vbH);
      const [r,g,b] = hexToRgb(hex);
      for (let i = 0; i < id.data.length; i += 4) {
        if (id.data[i+3] > 0) { id.data[i]=r; id.data[i+1]=g; id.data[i+2]=b; }
      }
      octx.putImageData(id, 0, 0);
      ctx.drawImage(off, 0, 0);
    }

    // Desenha WebP simples com blend mode opcional
    async function drawPlain(url, blend) {
      let img; try { img = await loadImg(url); } catch(e) { return; }
      ctx.save();
      if (blend) ctx.globalCompositeOperation = blend;
      ctx.drawImage(img, 0, 0, vbW, vbH);
      ctx.restore();
    }

    function getFlood(id) {
      const el = document.getElementById(id);
      return el ? el.getAttribute('flood-color') : null;
    }
    function isVisible(id) {
      const el = document.getElementById(id);
      return el && el.style.display !== 'none';
    }

    // Desenha WebP com transform SVG (translate + rotate opcional) aplicado no canvas
    async function drawColorTransformed(url, hex, offKey) {
      const off = gLogoOffset(offKey);
      const { x = 0, y = 0, r = 0, rx = 0, ry = 0 } = off;
      if (!x && !y && !r) { await drawColor(url, hex); return; }
      ctx.save();
      ctx.translate(x, y);
      if (r) { ctx.translate(rx, ry); ctx.rotate(-r * Math.PI / 180); ctx.translate(-rx, -ry); }
      await drawColor(url, hex);
      ctx.restore();
    }

    // 1. Sombra
    await drawPlain(gUrl(CDN + 'Sombra.webp'));

    // 2. Cor geral
    await drawColor(gUrl(CDN + 'CorGERAL.webp'), getFlood('parte-filter-flood-geral') || corAtual.hex);

    // 3. Partes (exceto listras e punho que ficam acima)
    for (const p of PARTES.filter(p => p.id !== 'listras' && p.id !== 'punho')) {
      if (!isVisible('parte-webp-' + p.id)) continue;
      await drawColor(gUrl(p.arquivo), getFlood('parte-filter-flood-' + p.id) || '#000000');
    }

    // 4. Estampas ativas (manga, tronco, shorts)
    for (const regiao of ['manga', 'tronco', 'shorts']) {
      const ativaId = estampaAtivaMap[regiao];
      if (!ativaId) continue;
      const estampa = ESTAMPAS.find(e => e.id === ativaId);
      if (!estampa) continue;
      for (const camada of estampa.camadas) {
        const flood = document.getElementById(`estampa-flood-${regiao}-${ativaId}-${camada.id}`);
        await drawColor(gUrlCamada(camada), flood ? flood.getAttribute('flood-color') : camada.cor);
      }
    }

    // 5. Halftone (só com estampa de tronco ativa)
    if (estampaAtivaMap['tronco'] && isVisible('parte-webp-halftone')) {
      await drawColor(gUrl(CDN + 'HalftoneCamiseta.webp'), getFlood('parte-filter-flood-halftone') || corAtual.hex);
    }

    // 6. Punho (acima das estampas de manga)
    if (isVisible('parte-webp-punho')) {
      await drawColor(gUrl(CDN + 'Punhos.webp'), getFlood('parte-filter-flood-punho') || '#000000');
    }

    // 7. Estampa lateral (acima do halftone)
    const lateralId = estampaAtivaMap['lateral'];
    if (lateralId) {
      const estampa = ESTAMPAS.find(e => e.id === lateralId);
      if (estampa) {
        for (const camada of estampa.camadas) {
          const flood = document.getElementById(`estampa-flood-lateral-${lateralId}-${camada.id}`);
          await drawColor(gUrlCamada(camada), flood ? flood.getAttribute('flood-color') : camada.cor);
        }
      }
    }

    // 8. Listras
    if (isVisible('parte-webp-listras')) {
      await drawColor(gUrl(CDN + 'Listras.webp'), getFlood('parte-filter-flood-listras') || '#000000');
    }

    // 9. Logos Sello (sem versão FEM — usam offset/rotate no canvas)
    await drawColorTransformed(CDN + 'logo-estrela-costas.webp',   getFlood('parte-filter-flood-logo-sello-costas')  || '#000000', 'sello_costas');
    await drawColorTransformed(CDN + 'logo-escrita-shorts.webp',   getFlood('parte-filter-flood-logo-sello-shorts')  || '#000000', 'sello_shorts');
    if (isVisible('parte-webp-logo-sello-peito-lado')) {
      await drawColorTransformed(CDN + 'logo-estrela-peito-lado.webp',   getFlood('parte-filter-flood-logo-sello-peito-lado')   || '#000000', 'sello_peito_lado');
    } else {
      await drawColorTransformed(CDN + 'logo-estrela-peito-centro.webp', getFlood('parte-filter-flood-logo-sello-peito-centro') || '#000000', 'sello_peito_centro');
    }

    // 10. Máscaras de degradê e estruturais (antes dos overlays)
    const corMascaraExp = coresPorParte['tronco'] || corAtual.hex;
    if (mascaraMangaAtiva) {
      if (modelo === 'signature') {
        await drawColor(gUrl(CDN + 'HalftoneSignatureManga.webp'), corMascaraExp);
      } else {
        await drawColor(gUrl(CDN + 'HalftoneOriginalManga.webp'), corMascaraExp);
      }
    }
    if (modelo === 'original') {
      await drawColor(gUrl(CDN + 'MascaraOriginal.webp'), corMascaraExp);
    }

    // 11. Overlay de acabamento
    await drawPlain(gUrl(gModelo(CDN + 'camiseta_shorts.superexposicao.webp')), 'multiply');
    await drawPlain(gUrl(gModelo(CDN + 'camiseta_shorts.screen.webp')), 'screen');

    // Desenha um <image> SVG respeitando preserveAspectRatio xMidYMid meet
    async function drawSVGImage(imgEl) {
      const href = imgEl.getAttribute('href') || imgEl.getAttribute('xlink:href');
      if (!href) return;
      try {
        const img = await loadImg(href);
        const elX = parseFloat(imgEl.getAttribute('x')) || 0;
        const elY = parseFloat(imgEl.getAttribute('y')) || 0;
        const elW = parseFloat(imgEl.getAttribute('width')) || img.naturalWidth;
        const elH = parseFloat(imgEl.getAttribute('height')) || img.naturalHeight;
        const imgAspect = img.naturalWidth / img.naturalHeight;
        const elAspect = elW / elH;
        let dW, dH, dX, dY;
        if (imgAspect > elAspect) {
          dW = elW; dH = elW / imgAspect;
          dX = elX; dY = elY + (elH - dH) / 2;
        } else {
          dH = elH; dW = elH * imgAspect;
          dX = elX + (elW - dW) / 2; dY = elY;
        }
        ctx.drawImage(img, dX, dY, dW, dH);
      } catch(e) {}
    }

    // 11. Logo do cliente (se carregado)
    const clienteEl = document.getElementById('logo-cliente');
    if (clienteEl && clienteEl.getAttribute('href') && clienteEl.style.display !== 'none') {
      await drawSVGImage(clienteEl);
    }

    // 11b. Segundo logo (duplo_logo)
    const clienteEl2 = document.getElementById('logo-cliente-2');
    if (clienteEl2 && clienteEl2.getAttribute('href') && clienteEl2.style.display !== 'none') {
      await drawSVGImage(clienteEl2);
    }

    // 12. Patrocinadores
    for (const lado of ['frente', 'costas']) {
      const g = document.getElementById('patron-g-' + lado);
      if (!g) continue;
      for (const imgEl of g.querySelectorAll('image')) {
        await drawSVGImage(imgEl);
      }
    }

    const dataUrl = canvas.toDataURL('image/png');
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS) {
      // iOS bloqueia popups e não suporta download de data URI — exibe overlay na própria página
      const overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:20px;gap:16px;';
      const img = document.createElement('img');
      img.src = dataUrl;
      img.style.cssText = 'max-width:100%;max-height:70vh;border-radius:8px;';
      const txt = document.createElement('p');
      txt.style.cssText = 'color:#fff;font-family:sans-serif;font-size:15px;text-align:center;margin:0;';
      txt.innerHTML = 'Segure a imagem e toque em <b>Salvar</b>';
      const fechar = document.createElement('button');
      fechar.textContent = 'Fechar';
      fechar.style.cssText = 'padding:10px 28px;border:none;border-radius:8px;background:#fff;font-size:15px;font-weight:700;cursor:pointer;';
      fechar.onclick = () => overlay.remove();
      overlay.appendChild(img);
      overlay.appendChild(txt);
      overlay.appendChild(fechar);
      document.body.appendChild(overlay);
    } else {
      const a = document.createElement('a');
      a.download = 'meu-uniforme.png'; a.href = dataUrl;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
    }
  } catch(e) {
    console.error('Erro ao gerar imagem:', e);
    alert('Erro ao gerar imagem: ' + e.message);
  }

  btn.classList.remove('loading');
  btn.innerHTML = btnLabel;
}

const _thumbCache = new Map();
async function _thumbDataUrl(href) {
  if (_thumbCache.has(href)) return _thumbCache.get(href);
  try {
    const resp = await fetch(href);
    const blob = await resp.blob();
    const dataUrl = await new Promise(r => { const fr = new FileReader(); fr.onload = () => r(fr.result); fr.readAsDataURL(blob); });
    _thumbCache.set(href, dataUrl);
    return dataUrl;
  } catch(e) { return null; }
}

let _thumbTimer = null;
async function atualizarThumbPreview() {
  if (window.innerWidth > 749) return;
  const canvas = document.getElementById('mockup-thumb-canvas');
  const wrap = document.getElementById('mockup-wrap');
  if (!canvas || !wrap) return;
  clearTimeout(_thumbTimer);
  const delay = _thumbCache.size === 0 ? 200 : 80;
  _thumbTimer = setTimeout(async () => {
    try {
      const svg = wrap.querySelector('svg');
      if (!svg) return;
      const clone = svg.cloneNode(true);
      const images = [...clone.querySelectorAll('image')];
      await Promise.all(images.map(async imgEl => {
        const href = imgEl.getAttribute('href') || imgEl.getAttribute('xlink:href');
        if (!href || href.startsWith('data:')) return;
        const dataUrl = await _thumbDataUrl(href);
        if (dataUrl) imgEl.setAttribute('href', dataUrl);
        else imgEl.remove();
      }));
      const svgStr = new XMLSerializer().serializeToString(clone);
      const blob = new Blob([svgStr], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);
      const img = new Image();
      img.onload = () => {
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(url);
      };
      img.onerror = () => URL.revokeObjectURL(url);
      img.src = url;
    } catch(e) {}
  }, delay);
}

function abrirPreviewOverlay() {
  const overlay = document.getElementById('preview-overlay');
  const slot = document.getElementById('mockup-overlay-slot');
  const mockup = document.getElementById('mockup-wrap');
  if (!overlay || !mockup) return;
  if (slot && mockup.parentElement !== slot) slot.appendChild(mockup);
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function fecharPreviewOverlay() {
  const overlay = document.getElementById('preview-overlay');
  const desk = document.getElementById('mockup-desktop-slot');
  const mockup = document.getElementById('mockup-wrap');
  if (!overlay) return;
  if (desk && mockup && mockup.parentElement !== desk) desk.appendChild(mockup);
  overlay.classList.remove('open');
  document.body.style.overflow = '';
  atualizarThumbPreview();
}

function solicitarOrcamento() {
  const WHATSAPP_NUM = '5511973609865';
  const REGIOES_LABEL = { manga: 'Mangas', tronco: 'Tronco', shorts: 'Shorts', lateral: 'Laterais' };

  let linhas = [];
  linhas.push('Olá! Quero orçamento para uniformes personalizados Sello Sports.');
  linhas.push('');

  const regioes = ['manga', 'lateral', 'tronco', 'shorts'];
  const estampasAtivas = regioes.filter(r => estampaAtivaMap[r]);
  if (estampasAtivas.length > 0) {
    linhas.push('*Estampas selecionadas:*');
    estampasAtivas.forEach(regiao => {
      const estampa = ESTAMPAS.find(e => e.id === estampaAtivaMap[regiao]);
      if (!estampa) return;
      const num = (estampa.nome.match(/\d+/) || ['1'])[0].padStart(2, '0');
      linhas.push(`  • ${REGIOES_LABEL[regiao]}: Estampa ${num}`);
    });
    linhas.push('');
  }

  const posLabel = posicaoAtual === 'lado_a_lado' ? 'Um de cada lado' : posicaoAtual === 'centralizado' ? 'Centralizado' : 'Duplo Logo';
  linhas.push(`*Posição dos logos:* ${posLabel}`);
  if (temEscudo) linhas.push('*Escudo proprio:* Sim');
  if (temEscudo2) linhas.push('*Segundo logo (Duplo Logo):* Sim');
  linhas.push('');
  linhas.push('*PROXIMOS PASSOS*');
  linhas.push('Por favor envie junto a esta mensagem:');
  linhas.push('  • A imagem do mockup (use o botao "Salvar modelo" no site)');
  linhas.push('  • O arquivo do seu escudo/logotipo');
  linhas.push('  • Os arquivos dos logos de patrocinadores (em alta qualidade), se houver');
  linhas.push('  • Quantidade desejada de uniformes');

  window.open(`https://wa.me/${WHATSAPP_NUM}?text=${encodeURIComponent(linhas.join('\n'))}`, '_blank');
}

// ── PATROCINADORES ──
const PATRON_ZONAS = {
  frente: { cx: 517, yTop: 460, yBot: 740, maxW: 360, max: 3 },
  costas: { cx: 1528, yTop: 225, yBot: 710, maxW: 280, max: 6 },
};

const patrocinadores = { frente: [], costas: [] };
let patronIdCounter = 0;

function layoutPatrocinadoresSVG(lado) {
  const NS = 'http://www.w3.org/2000/svg';
  const g = document.getElementById('patron-g-' + lado);
  if (!g) return;
  g.innerHTML = '';
  const lista = patrocinadores[lado];
  if (!lista.length) return;
  const zona = PATRON_ZONAS[lado];
  const gap = 40;

  // Calcula dimensões fixas de cada sponsor (tamanho não muda com N)
  const items = lista.map(p => {
    const aspect = p.nW && p.nH ? p.nW / p.nH : 3;
    const w = zona.maxW * p.scale;
    const h = w / aspect;
    return { p, w, h };
  });

  // Ambos os lados: anchor no topo — novos itens empilham abaixo sem mover o primeiro
  let y = zona.yTop + gLogoOffset('patrocinadores_' + lado).y;

  items.forEach(({ p, w, h }) => {
    const img = document.createElementNS(NS, 'image');
    img.setAttribute('x', zona.cx - w / 2);
    img.setAttribute('y', y);
    img.setAttribute('width', w);
    img.setAttribute('height', h);
    img.setAttribute('href', p._tintedSrc || p.src);
    img.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    g.appendChild(img);
    y += h + gap;
  });
}

function renderPatrocinadores(lado) {
  const container = document.getElementById('patron-lista-' + lado);
  if (!container) return;
  const zona = PATRON_ZONAS[lado];
  const lista = patrocinadores[lado];
  container.innerHTML = '';
  if (!lista.length) {
    const empty = document.createElement('div');
    empty.className = 'patron-empty';
    empty.textContent = 'Nenhum adicionado';
    container.appendChild(empty);
  } else {
    lista.forEach((p, i) => {
      const item = document.createElement('div');
      item.className = 'patron-item';
      item.draggable = true;
      item.dataset.id = p.id;
      item.dataset.lado = lado;
      item.innerHTML = `
        <div class="patron-drag-handle">⠿</div>
        <img class="patron-thumb" src="${p._tintedSrc || p.src}" alt="">
        <div class="patron-info">
          <span class="patron-nome">${p.nome.length > 16 ? p.nome.slice(0,14)+'…' : p.nome}</span>
          <div class="logo-size-controls visible">
            <button class="logo-size-btn" onclick="resizePatrocinador('${lado}',${p.id},-1)">−</button>
            <span class="logo-size-label" id="patron-scale-${p.id}">${Math.round(p.scale*100)}%</span>
            <button class="logo-size-btn" onclick="resizePatrocinador('${lado}',${p.id},1)">+</button>
          </div>
        </div>
        <button class="patron-remover" title="Remover" onclick="removerPatrocinador('${lado}',${p.id})"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="4" y1="4" x2="20" y2="20"/><line x1="20" y1="4" x2="4" y2="20"/></svg></button>
      `;
      // Color picker
      const corWrap = document.createElement('div');
      corWrap.className = 'parte-wrapper';
      corWrap.style.position = 'relative';
      const btnCor = document.createElement('div');
      btnCor.className = 'parte-btn-cor' + (p.cor ? ' active' : '');
      btnCor.id = 'patron-btn-cor-' + p.id;
      btnCor.style.background = p.cor ? (encontrarTomPorHex(p.cor)?.tom.hexSwatch || p.cor) : '#e0e0e0';
      btnCor.title = 'Cor do patrocinador';
      const btnNone = document.createElement('div');
      btnNone.className = 'parte-btn-none' + (!p.cor ? ' active' : '');
      btnNone.id = 'patron-btn-none-' + p.id;
      btnNone.title = 'Cores originais';
      btnNone.onclick = () => aplicarCorPatrocinador(lado, p.id, null);
      const popover = document.createElement('div');
      popover.className = 'color-picker-popover';
      const popTitle = document.createElement('div');
      popTitle.className = 'popover-title';
      popTitle.textContent = 'Cor do patrocinador';
      const { groupRow, toneRow, reset: resetPop } = criarSeletorCores({
        groupClass: 'pop-swatch', toneClass: 'pop-swatch',
        getHexAtivo: () => p.cor, isProibido: null,
        onSelectTom: tom => { aplicarCorPatrocinador(lado, p.id, tom.hex); fecharPopovers(); }
      });
      groupRow.className += ' popover-swatches';
      toneRow.className += ' popover-tones';
      popover.appendChild(popTitle); popover.appendChild(groupRow); popover.appendChild(toneRow);
      btnCor.onclick = e => {
        e.stopPropagation();
        const jaAberto = popover.classList.contains('open');
        fecharPopovers();
        if (!jaAberto) { resetPop(); abrirPopover(popover); }
      };
      corWrap.appendChild(btnCor); corWrap.appendChild(popover);
      const removerBtn = item.querySelector('.patron-remover');
      item.insertBefore(corWrap, removerBtn);
      item.insertBefore(btnNone, removerBtn);
      // Desktop drag-and-drop
      item.addEventListener('dragstart', e => {
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', p.id + '|' + lado);
        setTimeout(() => item.classList.add('dragging'), 0);
      });
      item.addEventListener('dragend', () => item.classList.remove('dragging'));
      item.addEventListener('dragover', e => { e.preventDefault(); item.classList.add('drag-over'); });
      item.addEventListener('dragleave', () => item.classList.remove('drag-over'));
      item.addEventListener('drop', e => {
        e.preventDefault();
        item.classList.remove('drag-over');
        const [dragId, dragLado] = e.dataTransfer.getData('text/plain').split('|');
        if (dragLado !== lado) return;
        const fromIdx = patrocinadores[lado].findIndex(x => x.id == dragId);
        if (fromIdx === i || fromIdx === -1) return;
        const [moved] = patrocinadores[lado].splice(fromIdx, 1);
        patrocinadores[lado].splice(i, 0, moved);
        renderPatrocinadores(lado);
        layoutPatrocinadoresSVG(lado);
      });
      container.appendChild(item);
    });
  }
  const btnAdd = document.getElementById('patron-add-' + lado);
  if (btnAdd) btnAdd.style.display = lista.length >= zona.max ? 'none' : '';
  const countEl = document.getElementById('patron-count-' + lado);
  if (countEl) countEl.textContent = `(${lista.length}/${zona.max})`;
  // Re-attach touch drag
  patronTouchDrag(container, lado);
}

function patronTouchDrag(container, lado) {
  let dragEl = null;
  container.addEventListener('touchstart', e => {
    const handle = e.target.closest('.patron-drag-handle');
    if (!handle) return;
    e.preventDefault();
    dragEl = handle.closest('.patron-item');
    dragEl.classList.add('dragging');
  }, { passive: false });
  container.addEventListener('touchmove', e => {
    if (!dragEl) return;
    e.preventDefault();
    const y = e.touches[0].clientY;
    container.querySelectorAll('.patron-item:not(.dragging)').forEach(it => {
      const r = it.getBoundingClientRect();
      it.classList.toggle('drag-over', y >= r.top && y < r.bottom);
    });
  }, { passive: false });
  container.addEventListener('touchend', e => {
    if (!dragEl) return;
    const y = e.changedTouches[0].clientY;
    const allItems = [...container.querySelectorAll('.patron-item')];
    const fromDomIdx = allItems.indexOf(dragEl);
    container.querySelectorAll('.patron-item').forEach(i => i.classList.remove('drag-over', 'dragging'));
    let toDomIdx = allItems.length;
    for (let i = 0; i < allItems.length; i++) {
      if (allItems[i] === dragEl) continue;
      const r = allItems[i].getBoundingClientRect();
      if (y < r.top + r.height / 2) { toDomIdx = i; break; }
    }
    const toDataIdx = toDomIdx > fromDomIdx ? toDomIdx - 1 : toDomIdx;
    if (fromDomIdx !== toDataIdx) {
      const [moved] = patrocinadores[lado].splice(fromDomIdx, 1);
      patrocinadores[lado].splice(toDataIdx, 0, moved);
      renderPatrocinadores(lado);
      layoutPatrocinadoresSVG(lado);
    }
    dragEl = null;
  });
}

function trimTransparencia(dataUrl) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const c = document.createElement('canvas');
      c.width = img.width; c.height = img.height;
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const d = ctx.getImageData(0, 0, c.width, c.height).data;
      let minX = c.width, minY = c.height, maxX = 0, maxY = 0;
      for (let y = 0; y < c.height; y++) {
        for (let x = 0; x < c.width; x++) {
          if (d[(y * c.width + x) * 4 + 3] > 8) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < minX || maxY < minY) { resolve(dataUrl); return; }
      const w = maxX - minX + 1, h = maxY - minY + 1;
      const c2 = document.createElement('canvas');
      c2.width = w; c2.height = h;
      c2.getContext('2d').drawImage(c, minX, minY, w, h, 0, 0, w, h);
      resolve(c2.toDataURL('image/png'));
    };
    img.src = dataUrl;
  });
}

function tintarImagem(src, hex) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width || 1; canvas.height = img.height || 1;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      let imageData;
      try { imageData = ctx.getImageData(0, 0, canvas.width, canvas.height); } catch(e) { resolve(src); return; }
      const data = imageData.data;
      let hasTransparency = false;
      for (let i = 3; i < data.length; i += 4) { if (data[i] < 200) { hasTransparency = true; break; } }
      const tr = parseInt(hex.slice(1,3),16), tg = parseInt(hex.slice(3,5),16), tb = parseInt(hex.slice(5,7),16);
      if (hasTransparency) {
        let totalLum = 0, count = 0;
        for (let i = 0; i < data.length; i += 4) {
          if (data[i+3] > 128) { totalLum += (0.299*data[i]+0.587*data[i+1]+0.114*data[i+2])/255; count++; }
        }
        const inkIsDark = count > 0 && (totalLum/count) < 0.5;
        for (let i = 0; i < data.length; i += 4) {
          if (data[i+3] === 0) continue;
          const lum = (0.299*data[i]+0.587*data[i+1]+0.114*data[i+2])/255;
          const mask = inkIsDark ? (1-lum) : lum;
          data[i]=Math.round(tr*mask); data[i+1]=Math.round(tg*mask); data[i+2]=Math.round(tb*mask);
        }
      } else {
        for (let i = 0; i < data.length; i += 4) {
          if (data[i+3] === 0) continue;
          const lum = (0.299*data[i]+0.587*data[i+1]+0.114*data[i+2])/255;
          data[i]=tr; data[i+1]=tg; data[i+2]=tb; data[i+3]=Math.round(255*(1-lum));
        }
      }
      ctx.putImageData(imageData, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.src = src;
  });
}

async function aplicarCorPatrocinador(lado, id, hex) {
  const p = patrocinadores[lado].find(x => x.id === id);
  if (!p) return;
  p.cor = hex;
  if (hex === null) {
    p._tintedSrc = null;
  } else {
    p._tintedSrc = await tintarImagem(p._originalSrc || p.src, hex);
  }
  layoutPatrocinadoresSVG(lado);
  // Atualiza botão na UI
  const btnCor = document.getElementById('patron-btn-cor-' + id);
  const btnNone = document.getElementById('patron-btn-none-' + id);
  if (btnCor) {
    const tom = hex ? encontrarTomPorHex(hex) : null;
    btnCor.style.background = hex ? (tom?.tom.hexSwatch || hex) : '#e0e0e0';
    btnCor.classList.toggle('active', !!hex);
  }
  if (btnNone) btnNone.classList.toggle('active', !hex);
}

async function adicionarPatrocinador(lado) {
  if (patrocinadores[lado].length >= PATRON_ZONAS[lado].max) return;
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  input.onchange = async e => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async ev => {
      const raw = ev.target.result;
      const _bgR = await jaTemTransparencia(raw) ? raw : await removeBgCanvas(raw);
      const src = await trimTransparencia(_bgR);
      const tmp = new Image();
      tmp.onload = () => {
        const id = ++patronIdCounter;
        patrocinadores[lado].push({ id, nome: file.name, src, _originalSrc: src, scale: 1, nW: tmp.naturalWidth, nH: tmp.naturalHeight, cor: null, _tintedSrc: null });
        renderPatrocinadores(lado);
        layoutPatrocinadoresSVG(lado);
      };
      tmp.src = src;
    };
    reader.readAsDataURL(file);
  };
  input.click();
}

function removerPatrocinador(lado, id) {
  patrocinadores[lado] = patrocinadores[lado].filter(p => p.id !== id);
  renderPatrocinadores(lado);
  layoutPatrocinadoresSVG(lado);
}

function resizePatrocinador(lado, id, delta) {
  const p = patrocinadores[lado].find(p => p.id === id);
  if (!p) return;
  p.scale = Math.max(0.2, Math.min(2.5, p.scale + delta * 0.1));
  const el = document.getElementById('patron-scale-' + id);
  if (el) el.textContent = Math.round(p.scale * 100) + '%';
  layoutPatrocinadoresSVG(lado);
}

const LOGO_POSICOES = {
  lado_a_lado:  { placeholder: [625, 292, 90, 90] },
  centralizado: { placeholder: [472.5, 320, 90, 90] },
  // Estrela centralizada + escudo no lado direito + segundo logo no lado esquerdo (onde a estrela ficaria em lado_a_lado)
  duplo_logo:   { placeholder: [625, 292, 90, 90], placeholder2: [320, 292, 90, 90] },
};

let posicaoAtual = 'lado_a_lado';

function reposicionarLogos(opt) {
  const ease = 'cubic-bezier(0.22,1,0.36,1)';
  const isDuplo = opt === 'duplo_logo';
  const isLado  = opt === 'lado_a_lado';

  // Estrela: duplo_logo usa a variante centro; lado_a_lado usa lado; centralizado usa centro
  const showId = isLado ? 'parte-webp-logo-sello-peito-lado' : 'parte-webp-logo-sello-peito-centro';
  const hideId = isLado ? 'parte-webp-logo-sello-peito-centro' : 'parte-webp-logo-sello-peito-lado';

  const hideEl = document.getElementById(hideId);
  const showEl = document.getElementById(showId);
  if (hideEl) {
    hideEl.style.transition = `opacity 0.18s ${ease}`;
    hideEl.style.opacity = '0';
    setTimeout(() => { hideEl.style.display = 'none'; hideEl.style.transition = ''; hideEl.style.opacity = ''; }, 200);
  }
  if (showEl) {
    showEl.style.display = '';
    showEl.style.transition = 'none';
    showEl.style.opacity = '0';
    void showEl.getBoundingClientRect();
    showEl.style.transition = `opacity 0.35s ${ease}`;
    showEl.style.opacity = '1';
    setTimeout(() => { showEl.style.transition = ''; showEl.style.opacity = ''; }, 380);
  }

  // Reposiciona placeholder e logo do cliente (escudo) com fade
  const logoMoveEls = ['logo-placeholder', 'logo-cliente'].map(id => document.getElementById(id)).filter(Boolean);
  logoMoveEls.forEach(el => { el.style.transition = `opacity 0.15s ${ease}`; el.style.opacity = '0'; });
  setTimeout(() => {
    const [x, y, w, h] = LOGO_POSICOES[opt].placeholder;
    const _off = gLogoOffset(gEscudoKey());
    logoMoveEls.forEach(el => {
      el.setAttribute('x', x + _off.x); el.setAttribute('y', y + _off.y);
      el.setAttribute('width', w); el.setAttribute('height', h);
      el.style.transition = `opacity 0.3s ${ease}`;
      el.style.opacity = '1';
      setTimeout(() => { el.style.transition = ''; el.style.opacity = ''; }, 320);
    });
  }, 160);

  // Segundo logo — só visível no modo duplo_logo
  const ph2 = document.getElementById('logo-placeholder-2');
  const lc2 = document.getElementById('logo-cliente-2');
  const secao2 = document.getElementById('secao-logo-2');
  if (isDuplo) {
    const [p2x, p2y, p2w, p2h] = LOGO_POSICOES.duplo_logo.placeholder2;
    const _off2 = gLogoOffset('escudo2');
    if (ph2) { ph2.setAttribute('x', p2x + _off2.x); ph2.setAttribute('y', p2y + _off2.y); }
    if (secao2) {
      secao2.style.display = '';
      secao2.style.opacity = '0';
      void secao2.getBoundingClientRect();
      secao2.style.transition = `opacity 0.35s ${ease}`;
      secao2.style.opacity = '1';
      setTimeout(() => { secao2.style.transition = ''; secao2.style.opacity = ''; }, 380);
    }
    if (ph2 && !temEscudo2) {
      ph2.style.display = '';
      ph2.style.opacity = '0';
      void ph2.getBoundingClientRect();
      ph2.style.transition = `opacity 0.35s ${ease}`;
      ph2.style.opacity = '1';
      setTimeout(() => { ph2.style.transition = ''; ph2.style.opacity = ''; }, 380);
    }
    if (lc2 && temEscudo2) {
      lc2.style.display = '';
      lc2.style.opacity = '0';
      void lc2.getBoundingClientRect();
      lc2.style.transition = `opacity 0.35s ${ease}`;
      lc2.style.opacity = '1';
      setTimeout(() => { lc2.style.transition = ''; lc2.style.opacity = ''; }, 380);
    }
    const up2 = document.getElementById('upload-zone-2');
    const st2 = document.getElementById('escudo2-status');
    if (up2) up2.style.display = temEscudo2 ? 'none' : '';
    if (st2) st2.style.display = temEscudo2 ? 'flex' : 'none';
  } else {
    if (secao2) {
      secao2.style.transition = `opacity 0.2s ${ease}`;
      secao2.style.opacity = '0';
      setTimeout(() => { secao2.style.display = 'none'; secao2.style.transition = ''; secao2.style.opacity = ''; }, 220);
    }
    if (ph2) {
      ph2.style.transition = `opacity 0.2s ${ease}`;
      ph2.style.opacity = '0';
      setTimeout(() => { ph2.style.display = 'none'; ph2.style.transition = ''; ph2.style.opacity = ''; }, 220);
    }
    if (lc2) {
      lc2.style.transition = `opacity 0.2s ${ease}`;
      lc2.style.opacity = '0';
      setTimeout(() => { lc2.style.display = 'none'; lc2.style.transition = ''; lc2.style.opacity = ''; }, 220);
    }
  }
}

function setPosicao(opt) {
  posicaoAtual = opt;
  reposicionarLogos(opt);
  if (temEscudo) setTimeout(() => applyLogoScale(), 210);
  if (temEscudo2 && opt === 'duplo_logo') setTimeout(() => applyLogoScale2(), 210);
  document.getElementById('btn-lado').classList.toggle('active', opt === 'lado_a_lado');
  document.getElementById('btn-centro').classList.toggle('active', opt === 'centralizado');
  document.getElementById('btn-duplo').classList.toggle('active', opt === 'duplo_logo');
}

async function trocarGenero(g) {
  if (genero === g) return;

  // Pré-carrega as imagens principais do novo gênero antes de mostrar
  const novoGenero = g;
  const _femSuffix = u => novoGenero === 'fem' ? u.replace(/(\.[^./]+)$/, 'FEM$1') : u;
  // Só as 4 camadas sempre visíveis; partes e máscaras carregam sob demanda
  const urlsParaPreload = [
    CDN + 'Sombra.webp', CDN + 'CorGERAL.webp',
    gModelo(CDN + 'camiseta_shorts.superexposicao.webp'), gModelo(CDN + 'camiseta_shorts.screen.webp'),
  ].map(_femSuffix);

  const svgEl = document.querySelector('#mockup-wrap svg');
  if (svgEl) { svgEl.style.transition = 'opacity 0.18s ease'; svgEl.style.opacity = '0'; }

  await Promise.all(urlsParaPreload.map(url =>
    new Promise(r => { const i = new Image(); i.onload = i.onerror = r; i.src = url; })
  ));

  genero = g;
  document.getElementById('btn-masc').classList.toggle('active', g === 'masc');
  document.getElementById('btn-fem').classList.toggle('active', g === 'fem');

  // Helper local para atualizar href de camada webp (zera antes para liberar memória)
  function atualizarHref(id, baseUrl) {
    const el = document.getElementById('parte-webp-' + id);
    if (!el) return;
    el.setAttribute('href', '');
    el.setAttribute('href', gUrl(baseUrl));
  }

  document.getElementById('parte-webp-sombra').setAttribute('href', gUrl(CDN + 'Sombra.webp'));
  atualizarHref('geral',                CDN + 'CorGERAL.webp');
  PARTES.forEach(p => atualizarHref(p.id, p.arquivo));
  atualizarHref('halftone',             CDN + 'HalftoneCamiseta.webp');
  // Logos da Sello não têm versão FEM — mantém os originais, mas desloca Y no feminino
  const _selloKeys = [
    ['logo-sello-peito-lado',   'sello_peito_lado'],
    ['logo-sello-peito-centro', 'sello_peito_centro'],
    ['logo-sello-costas',       'sello_costas'],
    ['logo-sello-shorts',       'sello_shorts'],
  ];
  _selloKeys.forEach(([id, key]) => {
    const el = document.getElementById('parte-webp-' + id);
    if (!el) return;
    if (g === 'fem') {
      const { x, y, r, rx, ry } = LOGO_OFFSET_FEM[key];
      if (x || y || r) {
        let t = `translate(${x || 0},${y || 0})`;
        if (r) t += ` rotate(${-r},${rx || 0},${ry || 0})`;
        el.setAttribute('transform', t);
      } else {
        el.removeAttribute('transform');
      }
    } else {
      el.removeAttribute('transform');
    }
  });

  const superexp = document.getElementById('mockup-superexposicao');
  if (superexp) { superexp.setAttribute('href', ''); superexp.setAttribute('href', gUrl(gModelo(CDN + 'camiseta_shorts.superexposicao.webp'))); }
  const screenEl = document.getElementById('mockup-screen');
  if (screenEl) { screenEl.setAttribute('href', ''); screenEl.setAttribute('href', gUrl(gModelo(CDN + 'camiseta_shorts.screen.webp'))); }
  const mascaraGeneroEl = document.getElementById('parte-webp-mascara-original');
  if (mascaraGeneroEl) { mascaraGeneroEl.setAttribute('href', ''); mascaraGeneroEl.setAttribute('href', gUrl(CDN + 'MascaraOriginal.webp')); }
  const mascaraMangaGeneroEl = document.getElementById('parte-webp-mascara-original-manga');
  if (mascaraMangaGeneroEl) { mascaraMangaGeneroEl.setAttribute('href', ''); mascaraMangaGeneroEl.setAttribute('href', gUrl(CDN + 'HalftoneOriginalManga.webp')); }
  const mascaraSignMangaGeneroEl = document.getElementById('parte-webp-mascara-signature-manga');
  if (mascaraSignMangaGeneroEl) { mascaraSignMangaGeneroEl.setAttribute('href', ''); mascaraSignMangaGeneroEl.setAttribute('href', gUrl(CDN + 'HalftoneSignatureManga.webp')); }

  // Recarrega estampas ativas com os arquivos do gênero correto
  Object.entries(estampaAtivaMap).forEach(([regiao, id]) => {
    if (!id) return;
    estampaAtivaMap[regiao] = null;
    ativarEstampa(regiao, id);
  });

  // Reposiciona logos do cliente e patrocinadores
  reposicionarLogos(posicaoAtual);
  if (temEscudo) applyLogoScale();
  if (temEscudo2 && posicaoAtual === 'duplo_logo') applyLogoScale2();
  ['frente', 'costas'].forEach(lado => layoutPatrocinadoresSVG(lado));

  if (svgEl) requestAnimationFrame(() => { svgEl.style.opacity = '1'; });
  atualizarThumbPreview();
}

async function trocarModelo(m) {
  if (modelo === m) return;

  const prefixo = m === 'original' ? 'camiseta_shortsORIGINAL.' : 'camiseta_shorts.';
  const urlsReais = [
    CDN + prefixo + 'superexposicao.webp', CDN + prefixo + 'screen.webp',
    CDN + prefixo + 'superexposicaoFEM.webp', CDN + prefixo + 'screenFEM.webp',
  ];

  const svgEl = document.querySelector('#mockup-wrap svg');
  if (svgEl) { svgEl.style.transition = 'opacity 0.18s ease'; svgEl.style.opacity = '0'; }

  await Promise.all(urlsReais.map(url =>
    new Promise(r => { const i = new Image(); i.onload = i.onerror = r; i.src = url; })
  ));

  modelo = m;
  document.getElementById('btn-signature').classList.toggle('active', m === 'signature');
  document.getElementById('btn-original').classList.toggle('active', m === 'original');

  const superexp = document.getElementById('mockup-superexposicao');
  if (superexp) superexp.setAttribute('href', gUrl(gModelo(CDN + 'camiseta_shorts.superexposicao.webp')));
  const screenEl = document.getElementById('mockup-screen');
  if (screenEl) screenEl.setAttribute('href', gUrl(gModelo(CDN + 'camiseta_shorts.screen.webp')));

  const mascaraEl = document.getElementById('parte-webp-mascara-original');
  if (mascaraEl) mascaraEl.style.display = m === 'original' ? '' : 'none';
  const mascaraMangaEl = document.getElementById('parte-webp-mascara-original-manga');
  if (mascaraMangaEl) mascaraMangaEl.style.display = (m === 'original' && mascaraMangaAtiva) ? '' : 'none';
  const mascaraSignMangaEl = document.getElementById('parte-webp-mascara-signature-manga');
  if (mascaraSignMangaEl) mascaraSignMangaEl.style.display = (m === 'signature' && mascaraMangaAtiva) ? '' : 'none';

  document.getElementById('comp-signature')?.classList.toggle('active', m === 'signature');
  document.getElementById('comp-original')?.classList.toggle('active', m === 'original');

  if (svgEl) requestAnimationFrame(() => { svgEl.style.opacity = '1'; });
  atualizarThumbPreview();
}

function toggleMascaraManga() {
  mascaraMangaAtiva = !mascaraMangaAtiva;
  const btn = document.getElementById('btn-toggle-degrade');
  if (btn) btn.classList.toggle('active', mascaraMangaAtiva);

  const ease = 'cubic-bezier(0.22,1,0.36,1)';
  function fadeToggle(el, show) {
    if (!el) return;
    if (show) {
      el.style.display = '';
      el.style.transition = 'none'; el.style.opacity = '0';
      void el.getBoundingClientRect();
      el.style.transition = `opacity 0.35s ${ease}`; el.style.opacity = '1';
      setTimeout(() => { el.style.transition = ''; el.style.opacity = ''; }, 380);
    } else {
      el.style.transition = `opacity 0.25s ${ease}`; el.style.opacity = '0';
      setTimeout(() => { el.style.display = 'none'; el.style.transition = ''; el.style.opacity = ''; }, 270);
    }
  }

  if (modelo === 'signature') {
    fadeToggle(document.getElementById('parte-webp-mascara-signature-manga'), mascaraMangaAtiva);
  } else {
    fadeToggle(document.getElementById('parte-webp-mascara-original-manga'), mascaraMangaAtiva);
  }
}

function toggleAccordion(btn) {
  btn.nextElementSibling.classList.toggle('open');
  btn.querySelector('.chevron').classList.toggle('open');
}

// ── PARTES WEBP ──


function criarWebpLayer(svg, defs, vbW, vbH, id, arquivo, corInicial, visivel) {
  const filterId = 'parte-color-' + id;
  const floodId  = 'parte-filter-flood-' + id;

  const filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
  filter.setAttribute('id', filterId);
  filter.setAttribute('x', '0'); filter.setAttribute('y', '0');
  filter.setAttribute('width', '1'); filter.setAttribute('height', '1');
  filter.setAttribute('color-interpolation-filters', 'sRGB');

  const flood = document.createElementNS('http://www.w3.org/2000/svg', 'feFlood');
  flood.setAttribute('id', floodId);
  flood.setAttribute('flood-color', corInicial);
  flood.setAttribute('result', 'color');

  const composite = document.createElementNS('http://www.w3.org/2000/svg', 'feComposite');
  composite.setAttribute('in', 'color');
  composite.setAttribute('in2', 'SourceGraphic');
  composite.setAttribute('operator', 'in');

  filter.appendChild(flood);
  filter.appendChild(composite);
  defs.appendChild(filter);

  const img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
  img.setAttribute('id', 'parte-webp-' + id);
  img.setAttribute('href', arquivo);
  if (!visivel) img.style.display = 'none';
  img.setAttribute('x', '0'); img.setAttribute('y', '0');
  img.setAttribute('width', vbW); img.setAttribute('height', vbH);
  img.setAttribute('filter', 'url(#' + filterId + ')');
  svg.appendChild(img);
}

function inicializarPartesWebp() {
  const svg = document.querySelector('#mockup-wrap svg');
  if (!svg) return;

  let defs = svg.querySelector('defs');
  if (!defs) { defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs'); svg.insertBefore(defs, svg.firstChild); }

  const vb = svg.getAttribute('viewBox') || '0 0 944.03 1000';
  const [,, vbW, vbH] = vb.split(' ').map(Number);

  // Sombra — camada mais baixa de todas, imagem estática sem filtro de cor
  const sombra = document.createElementNS('http://www.w3.org/2000/svg', 'image');
  sombra.setAttribute('id', 'parte-webp-sombra');
  sombra.setAttribute('href', gUrl(CDN + 'Sombra.webp'));
  sombra.setAttribute('x', '0'); sombra.setAttribute('y', '0');
  sombra.setAttribute('width', vbW); sombra.setAttribute('height', vbH);
  svg.appendChild(sombra);

  // Cor base geral — sempre visível, inserida acima da sombra
  criarWebpLayer(svg, defs, vbW, vbH, 'geral', gUrl(CDN + 'CorGERAL.webp'), corAtual.hex, true);

  PARTES.filter(p => p.id !== 'listras' && p.id !== 'punho').forEach(parte => {
    criarWebpLayer(svg, defs, vbW, vbH, parte.id, gUrl(parte.arquivo), '#000000', false);
  });

  // Halftone — acima das partes, abaixo dos logos e do overlay; só aparece com estampa de tronco ativa
  const corHalftone = coresPorParte['tronco'] || corAtual.hex;
  criarWebpLayer(svg, defs, vbW, vbH, 'halftone', gUrl(CDN + 'HalftoneCamiseta.webp'), corHalftone, false);

  // Punho — acima das estampas de manga
  criarWebpLayer(svg, defs, vbW, vbH, 'punho', gUrl(CDN + 'Punhos.webp'), '#000000', false);

  // Listras — acima do tronco e do halftone
  criarWebpLayer(svg, defs, vbW, vbH, 'listras', gUrl(CDN + 'Listras.webp'), '#000000', false);

  // Logos da Sello — acima das texturas, abaixo do overlay de acabamento
  criarWebpLayer(svg, defs, vbW, vbH, 'logo-sello-costas',       CDN + 'logo-estrela-costas.webp',       '#000000', true);
  criarWebpLayer(svg, defs, vbW, vbH, 'logo-sello-peito-lado',   CDN + 'logo-estrela-peito-lado.webp',   '#000000', posicaoAtual === 'lado_a_lado');
  criarWebpLayer(svg, defs, vbW, vbH, 'logo-sello-peito-centro', CDN + 'logo-estrela-peito-centro.webp', '#000000', posicaoAtual === 'centralizado');
  criarWebpLayer(svg, defs, vbW, vbH, 'logo-sello-shorts',       CDN + 'logo-escrita-shorts.webp',       '#000000', true);

  // MascaraSignatureManga — degradê de manga Signature (toggle)
  const corMascaraSignManga = coresPorParte['tronco'] || corAtual.hex;
  criarWebpLayer(svg, defs, vbW, vbH, 'mascara-signature-manga', gUrl(CDN + 'HalftoneSignatureManga.webp'), corMascaraSignManga, false);
  const mascaraSignMangaEl = document.getElementById('parte-webp-mascara-signature-manga');
  if (mascaraSignMangaEl) mascaraSignMangaEl.style.display = (modelo === 'signature' && mascaraMangaAtiva) ? '' : 'none';

  // MascaraOriginalManga — degradê de manga Original (toggle)
  const corMascaraManga = coresPorParte['tronco'] || corAtual.hex;
  criarWebpLayer(svg, defs, vbW, vbH, 'mascara-original-manga', gUrl(CDN + 'HalftoneOriginalManga.webp'), corMascaraManga, false);
  const mascaraMangaEl = document.getElementById('parte-webp-mascara-original-manga');
  if (mascaraMangaEl) mascaraMangaEl.style.display = (modelo === 'original' && mascaraMangaAtiva) ? '' : 'none';

  const corMascara = coresPorParte['tronco'] || corAtual.hex;
  criarWebpLayer(svg, defs, vbW, vbH, 'mascara-original', gUrl(CDN + 'MascaraOriginal.webp'), corMascara, false);
  const mascaraEl = document.getElementById('parte-webp-mascara-original');
  if (mascaraEl) mascaraEl.style.display = modelo === 'original' ? '' : 'none';

  // Camadas de acabamento do mockup — ficam acima de cores, texturas e halftone
  const superexp = document.createElementNS('http://www.w3.org/2000/svg', 'image');
  superexp.setAttribute('id', 'mockup-superexposicao');
  superexp.setAttribute('href', gUrl(gModelo(CDN + 'camiseta_shorts.superexposicao.webp')));
  superexp.setAttribute('x', '0'); superexp.setAttribute('y', '0');
  superexp.setAttribute('width', vbW); superexp.setAttribute('height', vbH);
  superexp.style.mixBlendMode = 'multiply';
  svg.appendChild(superexp);

  const screen = document.createElementNS('http://www.w3.org/2000/svg', 'image');
  screen.setAttribute('id', 'mockup-screen');
  screen.setAttribute('href', gUrl(gModelo(CDN + 'camiseta_shorts.screen.webp')));
  screen.setAttribute('x', '0'); screen.setAttribute('y', '0');
  screen.setAttribute('width', vbW); screen.setAttribute('height', vbH);
  screen.style.mixBlendMode = 'screen';
  svg.appendChild(screen);
}

(function inicializar() {
  const wrap = document.getElementById('mockup-wrap');
  const loading = document.getElementById('mockup-svg-loading');
  if (loading) loading.remove();

  const NS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('viewBox', '0 0 2040 1734');
  svg.setAttribute('xmlns', NS);
  svg.style.width = '100%';
  svg.style.height = '100%';
  svg.style.display = 'block';

  const defs = document.createElementNS(NS, 'defs');
  svg.appendChild(defs);

  wrap.appendChild(svg);

  buildCores();
  buildPartes();
  inicializarPartesWebp();
  buildEstampas();

  // Cor padrão: uniforme branco, manga preta
  const _pretoPadrao = GRUPOS_CORES[0].rep;
  coresPorParte['manga'] = _pretoPadrao;
  const _mangaFlood = document.getElementById('parte-filter-flood-manga');
  if (_mangaFlood) _mangaFlood.setAttribute('flood-color', _pretoPadrao.hex);
  const _mangaEl = document.getElementById('parte-webp-manga');
  if (_mangaEl) { _mangaEl.style.display = ''; _mangaEl.style.opacity = ''; }
  aplicarHalftoneTronco();

  // Placeholder e logo do cliente — appended por último para ficarem acima de todas as camadas
  const [px, py, pw, ph] = LOGO_POSICOES[posicaoAtual].placeholder;
  const placeholder = document.createElementNS(NS, 'image');
  placeholder.setAttribute('id', 'logo-placeholder');
  placeholder.setAttribute('x', px); placeholder.setAttribute('y', py);
  placeholder.setAttribute('width', pw); placeholder.setAttribute('height', ph);
  svg.appendChild(placeholder);

  const logoCliente = document.createElementNS(NS, 'image');
  logoCliente.setAttribute('id', 'logo-cliente');
  logoCliente.setAttribute('x', px); logoCliente.setAttribute('y', py);
  logoCliente.setAttribute('width', pw * 2); logoCliente.setAttribute('height', ph * 2);
  svg.appendChild(logoCliente);

  // Segundo logo (duplo_logo) — placeholder e imagem, ocultos por padrão
  const p2 = LOGO_POSICOES.duplo_logo.placeholder2;
  const placeholder2 = document.createElementNS(NS, 'image');
  placeholder2.setAttribute('id', 'logo-placeholder-2');
  placeholder2.setAttribute('x', p2[0]); placeholder2.setAttribute('y', p2[1]);
  placeholder2.setAttribute('width', p2[2]); placeholder2.setAttribute('height', p2[3]);
  placeholder2.style.display = 'none';
  svg.appendChild(placeholder2);

  const logoCliente2 = document.createElementNS(NS, 'image');
  logoCliente2.setAttribute('id', 'logo-cliente-2');
  logoCliente2.setAttribute('x', p2[0]); logoCliente2.setAttribute('y', p2[1]);
  logoCliente2.setAttribute('width', p2[2] * 2); logoCliente2.setAttribute('height', p2[3] * 2);
  logoCliente2.style.display = 'none';
  svg.appendChild(logoCliente2);

  aplicarCorLogosPeito(null);
  aplicarCorLogosShorts(null);
  atualizarPlaceholder();

  // Grupos de patrocinadores — abaixo do multiply/screen, acima das cores e texturas
  const _superexp = svg.querySelector('#mockup-superexposicao');
  ['frente', 'costas'].forEach(lado => {
    const g = document.createElementNS(NS, 'g');
    g.setAttribute('id', 'patron-g-' + lado);
    if (_superexp) svg.insertBefore(g, _superexp);
    else svg.appendChild(g);
  });

  renderPatrocinadores('frente');
  renderPatrocinadores('costas');
  buildCorLogo2();
  atualizarThumbPreview();

  // Observa mudanças no SVG e atualiza o thumbnail automaticamente
  const _svgRoot = document.querySelector('#mockup-wrap svg');
  if (_svgRoot) {
    new MutationObserver(() => atualizarThumbPreview())
      .observe(_svgRoot, { attributes: true, childList: true, subtree: true });
  }
})();